var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _circle, _circle2, _circle3, _circle4, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _path27, _rect88, _rect89, _path28, _path29, _path30, _path31, _path32, _circle5, _circle6, _circle7, _path33, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _path34, _circle14, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _g, _path174, _g2, _path175, _g3, _path176, _g4, _path177, _g5, _path178, _g6, _path179, _g7, _path180, _g8, _path181, _g9, _path182, _g10, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _g11, _path217, _g12, _path218, _g13, _path219, _g14, _path220, _g15, _path221, _g16, _path222, _g17, _path223, _g18, _path224, _g19, _path225, _g20, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSignuphero = function SvgSignuphero(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 574,
    height: 300,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M373.748 151.204c-.008.067-.008.14-.022.207-.008.058-.03.11-.044.162-.015.066-.03.132-.059.191l-.067.155a2.23 2.23 0 0 1-.095.198c-.03.052-.059.096-.089.148a2.127 2.127 0 0 1-.154.228c-.03.044-.066.088-.103.133-.081.103-.177.198-.272.294-.037.037-.067.074-.103.103-.059.059-.133.111-.199.162a1.682 1.682 0 0 1-.184.14c-.074.052-.155.103-.228.155-.081.051-.162.11-.243.154l-.037 7.703.081-.044c.059-.037.11-.074.169-.111.081-.051.162-.103.228-.154.067-.044.126-.096.184-.147.067-.052.133-.111.199-.162.015-.015.03-.023.037-.03.022-.022.044-.051.066-.074.096-.095.191-.191.272-.294.015-.022.045-.044.059-.066l.044-.067c.059-.073.104-.147.155-.228.022-.029.044-.066.066-.096a.25.25 0 0 0 .022-.051 2.26 2.26 0 0 0 .096-.199c.015-.037.037-.081.052-.118.007-.015.007-.029.014-.044.022-.066.037-.125.059-.192.015-.044.03-.088.037-.132 0-.015 0-.022.007-.037.015-.066.015-.132.022-.206a.742.742 0 0 0 .015-.133v-.059l.037-7.702c-.007.088-.022.154-.022.213ZM287.798 151.12l-.037 7.703c0 .965.633 1.93 1.906 2.666l.037-7.703c-1.273-.729-1.913-1.701-1.906-2.666Z",
    fill: "#5AB5BC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m371.886 153.649-.037 7.703-36.436 21.186.037-7.703 36.436-21.186ZM326.316 174.828l-.036 7.71-36.672-21.186.037-7.703 36.671 21.179Z",
    fill: "#5AB5BC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M334.809 182.847c.214-.095.412-.199.611-.309l.037-7.703a6.842 6.842 0 0 1-.611.31c-.059.029-.125.051-.184.081a8.299 8.299 0 0 1-.508.191c-.066.022-.125.044-.184.066-.11.037-.221.067-.331.096l-.258.066c-.117.03-.235.052-.353.074-.081.015-.162.037-.243.052-.243.044-.485.073-.736.103l-.228.022a9.322 9.322 0 0 1-.441.029c-.096.008-.184.008-.28.008h-.353c-.096 0-.199-.008-.295-.008-.11-.007-.22-.007-.331-.015l-.294-.022c-.111-.007-.214-.022-.324-.036l-.287-.045c-.118-.014-.228-.036-.346-.059-.088-.014-.176-.036-.265-.051-.132-.03-.272-.066-.405-.096-.073-.022-.147-.037-.22-.059a6.944 6.944 0 0 1-.692-.235c-.111-.045-.221-.089-.324-.14-.051-.022-.11-.045-.169-.074a7.173 7.173 0 0 1-.471-.25l-.098 3.664.061 4.038c.155.089.309.17.471.251.052.029.11.051.169.073.096.045.192.089.295.126.014.007.022.007.036.014.221.089.457.162.692.236.022.007.037.015.059.022l.162.044c.132.037.265.066.405.096.037.007.073.022.11.029.052.008.103.015.162.03.118.022.228.044.346.059l.14.022c.051.007.103.007.147.015.11.014.213.022.324.036.051.008.103.015.154.015.044.007.096.007.148.007.11.008.22.015.323.015.059 0 .111.008.17.008H331.262c.037 0 .066-.008.103-.008.147-.007.294-.015.442-.029.058-.008.117-.008.176-.015.015 0 .037-.007.052-.007.25-.03.493-.059.736-.103.014 0 .022 0 .036-.008l.206-.044c.118-.022.243-.052.361-.074l.258-.066c.11-.029.22-.059.331-.096.022-.007.051-.014.073-.022.037-.014.074-.029.118-.044.169-.059.339-.125.508-.191.022-.037.081-.067.147-.089Z",
    fill: "#5AB5BC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M371.857 148.347c2.531 1.465 2.546 3.837.029 5.295l-36.436 21.186c-2.517 1.465-6.609 1.458-9.133 0l-36.672-21.186c-2.532-1.466-2.546-3.837-.037-5.295l36.436-21.186c2.517-1.466 6.609-1.466 9.141 0l36.672 21.186Z",
    fill: "url(#signuphero_svg__a)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M366.815 151.543a2.163 2.163 0 0 1-.184.265 3.744 3.744 0 0 1-1.082.899l-.743.434-30.078 17.49c-2.127 1.237-5.586 1.237-7.727 0l-30.306-17.512-.714-.412c-.471-.273-.846-.589-1.111-.921a1.908 1.908 0 0 1-.191-.265c-.685-1.112-.258-2.401 1.265-3.292l30.829-17.916c2.127-1.237 5.585-1.237 7.727 0l31.027 17.916c1.546.891 1.98 2.195 1.288 3.314Z",
    fill: "#BEF0F4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M366.624 151.808a3.76 3.76 0 0 1-1.082.899l-.743.434-30.078 17.489c-2.127 1.238-5.586 1.238-7.727 0l-30.306-17.511-.714-.412c-.471-.273-.847-.59-1.111-.921.257-.324.618-.626 1.074-.898l30.828-17.917c2.127-1.237 5.586-1.237 7.728 0l31.027 17.917c.478.272.839.589 1.104.92Z",
    fill: "url(#signuphero_svg__b)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M330.887 167.56c-.221 0-.412-.022-.552-.044a1.63 1.63 0 0 1-.442-.162l-24.389-14.088a1.42 1.42 0 0 1 0-2.459l24.132-14.028c.154-.089.309-.148.485-.177.133-.022.302-.037.493-.037.221 0 .405.022.552.044.155.03.302.089.442.162l24.389 14.08c.942.545.949 1.907.007 2.46l-24.131 14.028a1.45 1.45 0 0 1-.486.177 2.51 2.51 0 0 1-.5.044Z",
    stroke: "#E8FCFE",
    strokeWidth: 0.359,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M330.843 162.294c-.148 0-.273-.014-.368-.029a.798.798 0 0 1-.287-.111l-16.095-9.3a.933.933 0 0 1 0-1.62l15.925-9.257a1.05 1.05 0 0 1 .317-.118 2.164 2.164 0 0 1 .684.008.92.92 0 0 1 .295.11l16.094 9.294a.933.933 0 0 1 0 1.62l-15.925 9.256a1.025 1.025 0 0 1-.317.118 1.912 1.912 0 0 1-.323.029Z",
    stroke: "#65DCE5",
    strokeWidth: 0.359,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M457.003 71.163c-1.682 0-4.439 1.753-4.907 2.804 37.033 21.963 112.711 65.538 114.954 66.939 2.243 1.402 2.803 3.505 2.803 4.556l3.49-2.151c0-4.206-1.737-5.135-2.438-5.559-33.654-20.361-98.044-58.824-111.449-66.09-1.438-.78-2.29-.499-2.453-.499Z",
    fill: "url(#signuphero_svg__c)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M573.343 227.122v-1.101l-3.504 2.453-.351 2.103 2.668-1.456a2.277 2.277 0 0 0 1.187-1.999Z",
    fill: "#BEE2E9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBEB",
    d: "m570.084 152.622 3.26-1.882v12.369l-3.26 1.882z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2FDFF",
    d: "m570.084 169.052 3.26-1.882v28.896l-3.26 1.882z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#D0E5E7",
    d: "m570.084 164.992 3.26-1.882v4.06l-3.26 1.882zM570.084 197.948l3.26-1.882v.982l-3.26 1.882z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2FDFF",
    d: "m570.084 198.928 3.26-1.882v29.497l-3.26 1.882z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m573.343 163.048-3.25 1.955v63.419l3.25-1.877v-63.497Z",
    fill: "#C8E4E9",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.86603 -.5 0 1 570.093 144.931)",
    fill: "url(#signuphero_svg__d)",
    d: "M0 0h3.753v7.686H0z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M452.082 86.192c0-7.548 5.258-10.539 11.745-6.68l94.521 56.234c6.486 3.86 11.745 13.107 11.745 20.655v61.817c0 7.549-5.259 10.539-11.745 6.68l-102.351-60.893c-2.162-1.286-3.915-4.369-3.915-6.885V86.192Z",
    fill: "#F5F5F5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m472.032 106.7 98.061 58.34v62.29c0 2.516-1.753 3.513-3.915 2.226l-94.146-56.011V106.7Z",
    fill: "#D0E5E7"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.8594 .5113 0 1 474.953 112.443)",
    fill: "url(#signuphero_svg__e)",
    d: "M0 0h110.704v28.957H0z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.8594 .5113 0 1 474.953 142.51)",
    fill: "url(#signuphero_svg__f)",
    d: "M0 0h35.191v29.482H0z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.8594 .5113 0 1 506.312 161.166)",
    fill: "url(#signuphero_svg__g)",
    d: "M0 0h35.191v29.482H0z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M523.234 186.943c.156.09.305.248.415.438.11.191.172.399.172.579v8.13c0 .179-.062.316-.172.38-.11.063-.259.048-.415-.042l-1.173-.677a1.196 1.196 0 0 1-.415-.438 1.204 1.204 0 0 1-.172-.578v-8.13c0-.18.062-.317.172-.38.11-.064.259-.049.415.041l1.173.677Zm3.148 5.883c.156.09.305.247.415.438.11.19.172.398.172.578v4.065c0 .18-.062.316-.172.38-.11.063-.259.049-.415-.041l-1.173-.678a1.188 1.188 0 0 1-.415-.438 1.198 1.198 0 0 1-.172-.578v-4.065c0-.18.062-.316.172-.38.11-.063.259-.049.415.041l1.173.678Zm3.129-6.324c.155.09.304.247.415.438.11.19.171.398.171.578v12.195c0 .18-.061.317-.171.38-.111.064-.26.049-.415-.041l-1.174-.677a1.212 1.212 0 0 1-.415-.438 1.205 1.205 0 0 1-.172-.579v-12.195c0-.18.062-.316.172-.38.11-.063.26-.048.415.041l1.174.678Zm3.111 1.796c.156.09.305.248.415.438.11.191.172.399.172.579v12.195c0 .179-.062.316-.172.38-.11.063-.259.048-.415-.041l-1.173-.678a1.196 1.196 0 0 1-.415-.438 1.204 1.204 0 0 1-.172-.578V187.96c0-.18.062-.317.172-.38.11-.064.259-.049.415.041l1.173.677Z",
    fill: "#37ADBD"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.8594 .5113 0 1 537.671 179.823)",
    fill: "url(#signuphero_svg__h)",
    d: "M0 0h37.727v29.482H0z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M546.708 197.418c0-1.995.656-3.536 1.836-4.312 1.18-.775 2.795-.727 4.519.135v4.214c-.479-.196-.936-.255-1.336-.171-.4.084-.733.308-.972.656-.24.347-.38.809-.41 1.349-.03.541.051 1.146.236 1.769s.47 1.249.833 1.828a7.086 7.086 0 0 0 1.261 1.515c.467.418.957.723 1.432.894.476.171.925.202 1.312.091l2.581 4.469c-.985.426-2.197.372-3.491-.155s-2.615-1.505-3.806-2.817a16.35 16.35 0 0 1-2.91-4.58c-.709-1.679-1.085-3.375-1.085-4.885Z",
    fill: "#A8E7EF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M553.971 197.978v-4.213c1.105.724 2.176 1.738 3.12 2.954a16.539 16.539 0 0 1 2.293 4.025l-3.367-.216c-.504-1.034-1.237-1.948-2.046-2.55Z",
    fill: "#2EA7B7"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M560.325 205.28c.003 1.906-.596 3.4-1.684 4.204v-.001l-2.58-4.469c.325-.314.534-.783.606-1.363.072-.579.004-1.25-.195-1.948l3.32.214c.343 1.137.533 2.279.533 3.363Z",
    fill: "#741F59"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M452.082 76.723c0-2.516 1.753-3.513 3.915-2.227l110.181 65.551c2.162 1.287 3.915 4.369 3.915 6.885v5.685l-118.011-70.21v-5.684Z",
    fill: "url(#signuphero_svg__i)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 3.733,
    transform: "matrix(.8594 .5113 0 1 460.289 94.32)",
    fill: "#537075"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 1.298,
    transform: "matrix(.8594 .5113 0 1 555.639 138.897)",
    fill: "#F4D7ED"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    r: 1.298,
    transform: "matrix(.8594 .5113 0 1 559.728 141.33)",
    fill: "#F4D7ED"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    r: 1.298,
    transform: "matrix(.8594 .5113 0 1 563.817 143.763)",
    fill: "#F4D7ED"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 11.156,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 456.19 99.982)",
    fill: "#8A9EA0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 11.156,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 456.19 103.443)",
    fill: "#8A9EA0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 8.73,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 524.141 131.011)",
    fill: "#8A9EA0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 8.73,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 533.503 136.58)",
    fill: "#8A9EA0"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 8.73,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 542.864 142.15)",
    fill: "#8A9EA0"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 8.73,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 552.226 147.719)",
    fill: "#8A9EA0"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 11.452,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 460.289 110.103)",
    fill: "#8A9EA0"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 11.452,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 460.289 113.564)",
    fill: "#8A9EA0"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 11.452,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 460.289 117.024)",
    fill: "#8A9EA0"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 11.452,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 478.904 149.55)",
    fill: "#459DAA"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 5.555,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 478.904 152.578)",
    fill: "#BBDEE4"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 5.555,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 478.904 155.606)",
    fill: "#BBDEE4"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 11.452,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 478.904 158.634)",
    fill: "#BBDEE4"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 11.452,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 509.117 167.525)",
    fill: "#459DAA"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 5.555,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 509.117 170.553)",
    fill: "#BBDEE4"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 5.555,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 509.117 173.581)",
    fill: "#BBDEE4"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 11.452,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 509.117 176.609)",
    fill: "#BBDEE4"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    width: 11.452,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 509.117 183.314)",
    fill: "#BBDEE4"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    width: 5.555,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 509.117 186.342)",
    fill: "#BBDEE4"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    width: 11.452,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 539.566 202.89)",
    fill: "#BBDEE4"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    width: 5.555,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 539.566 205.918)",
    fill: "#BBDEE4"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    width: 5.555,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 491.756 157.196)",
    fill: "#BBDEE4"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    width: 11.452,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 491.756 160.224)",
    fill: "#459DAA"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    width: 11.452,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 491.756 163.252)",
    fill: "#459DAA"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    width: 5.555,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 491.756 166.28)",
    fill: "#459DAA"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    width: 5.555,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 478.904 163.392)",
    fill: "#BBDEE4"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    width: 5.555,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 478.904 166.853)",
    fill: "#BBDEE4"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    width: 11.452,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 478.904 170.313)",
    fill: "#BBDEE4"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    width: 11.452,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 479.535 118.384)",
    fill: "#459DAA"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    width: 11.452,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 479.535 121.412)",
    fill: "#62CDD6"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    width: 11.452,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 479.535 124.44)",
    fill: "#62CDD6"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    width: 11.452,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 479.535 127.468)",
    fill: "#62CDD6"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    width: 11.452,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 479.535 130.496)",
    fill: "#62CDD6"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    width: 11.452,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 494.326 127.184)",
    fill: "#459DAA"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    width: 7.876,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 494.326 133.24)",
    fill: "url(#signuphero_svg__j)"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    width: 11.452,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 509.117 135.984)",
    fill: "#459DAA"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    width: 4.959,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 511.907 140.671)",
    fill: "#459DAA"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    width: 11.452,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 509.117 142.04)",
    fill: "#62CDD6"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    width: 4.959,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 511.907 146.727)",
    fill: "#459DAA"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    width: 4.959,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 511.907 149.755)",
    fill: "#459DAA"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    width: 11.452,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 523.909 144.784)",
    fill: "#459DAA"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    width: 11.452,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 523.909 147.812)",
    fill: "#BBDEE4"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    width: 11.452,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 523.909 147.812)",
    fill: "#BBDEE4"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    width: 6.139,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 523.909 147.812)",
    fill: "#BBDEE4"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    width: 6.139,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 523.909 147.812)",
    fill: "#62CDD6"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    width: 11.452,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 494.327 130.21)",
    fill: "#BBDEE4"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    width: 11.452,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 494.327 130.21)",
    fill: "#BBDEE4"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    width: 6.139,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 494.327 130.21)",
    fill: "#BBDEE4"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    width: 6.139,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 494.327 130.21)",
    fill: "#62CDD6"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    width: 11.452,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 494.327 136.266)",
    fill: "#BBDEE4"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    width: 11.452,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 494.327 136.266)",
    fill: "#BBDEE4"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    width: 6.139,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 494.327 136.266)",
    fill: "#BBDEE4"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    width: 6.139,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 494.327 136.266)",
    fill: "#62CDD6"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    width: 7.936,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 494.327 133.238)",
    fill: "#BBDEE4"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    width: 7.936,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 494.327 133.238)",
    fill: "#BBDEE4"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    width: 4.254,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 494.327 133.238)",
    fill: "#BBDEE4"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    width: 4.254,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 494.327 133.238)",
    fill: "#62CDD6"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    width: 7.936,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 494.327 139.294)",
    fill: "#BBDEE4"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    width: 7.936,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 494.327 139.294)",
    fill: "#BBDEE4"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    width: 4.254,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 494.327 139.294)",
    fill: "#BBDEE4"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    width: 4.254,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 494.327 139.294)",
    fill: "#62CDD6"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    width: 11.452,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 523.909 151.021)",
    fill: "#BBDEE4"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    width: 11.452,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 523.909 151.021)",
    fill: "#BBDEE4"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    width: 6.139,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 523.909 151.021)",
    fill: "#BBDEE4"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    width: 6.139,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 523.909 151.021)",
    fill: "#62CDD6"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    width: 11.452,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 523.909 153.825)",
    fill: "#BBDEE4"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    width: 11.452,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 523.909 153.825)",
    fill: "#BBDEE4"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    width: 6.139,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 523.909 153.825)",
    fill: "#BBDEE4"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    width: 6.139,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 523.909 153.825)",
    fill: "#62CDD6"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    width: 11.452,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 523.909 156.628)",
    fill: "#BBDEE4"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    width: 11.452,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 523.909 156.628)",
    fill: "#BBDEE4"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    width: 6.139,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 523.909 156.628)",
    fill: "#BBDEE4"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    width: 6.139,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 523.909 156.628)",
    fill: "#62CDD6"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    width: 11.452,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 538.7 153.584)",
    fill: "#459DAA"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    width: 6.477,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 540.837 157.883)",
    fill: "#62CDD6"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    width: 6.477,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 540.837 160.911)",
    fill: "#62CDD6"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    width: 6.477,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 540.837 163.939)",
    fill: "#62CDD6"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    width: 6.477,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 540.837 166.967)",
    fill: "#62CDD6"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    width: 11.452,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 553.491 162.383)",
    fill: "#459DAA"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    width: 11.452,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 553.491 165.411)",
    fill: "#C1E1E7"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    width: 11.452,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 553.491 168.439)",
    fill: "#C1E1E7"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    width: 11.452,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 553.491 171.467)",
    fill: "#C1E1E7"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    width: 11.452,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 553.491 174.495)",
    fill: "#C1E1E7"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    width: 11.452,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 456.19 120.18)",
    fill: "#8A9EA0"
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    width: 11.452,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 456.19 123.64)",
    fill: "#8A9EA0"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    width: 11.452,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 456.19 127.101)",
    fill: "#8A9EA0"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    width: 11.452,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 456.19 130.561)",
    fill: "#8A9EA0"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M458.098 83.107c0 .415-.293.583-.654.374-.361-.208-.653-.713-.653-1.129 0-.415.292-.583.653-.375.361.208.654.714.654 1.13ZM459.319 83.06c-.361-.209-.653-.04-.653.375s.292.92.653 1.13c.361.207.653.04.653-.376 0-.415-.292-.921-.653-1.13ZM461.194 84.142c-.361-.208-.653-.04-.653.375 0 .416.292.921.653 1.13.361.208.653.04.653-.375 0-.416-.292-.921-.653-1.13ZM461.421 82.457v-.504c.249.037.426-.136.426-.459 0-.415-.292-.921-.653-1.13-.361-.208-.653-.04-.653.376 0 .07.009.144.025.218l-.92.528a1.202 1.202 0 0 0-.327-.29.546.546 0 0 0-.347-.085l-.907-1.568a.659.659 0 0 0 .033-.214c0-.415-.293-.921-.654-1.13-.361-.208-.653-.04-.653.376 0 .323.177.7.426.95v.504c-.249-.037-.426.136-.426.459 0 .415.292.921.653 1.13.361.208.654.04.654-.376 0-.323-.178-.7-.427-.95v-.505a.427.427 0 0 0 .109.003l.914 1.58a.65.65 0 0 0-.028.2c0 .416.292.921.653 1.13.361.208.653.04.653-.375 0-.086-.013-.176-.036-.266l.902-.517c.04.053.083.102.129.148v.504c-.249-.037-.426.136-.426.459 0 .415.292.921.653 1.13.361.208.653.04.653-.376 0-.323-.177-.7-.426-.95Z",
    fill: "#fff"
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    width: 16.221,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 471.708 99.853)",
    fill: "#8A9EA0"
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    width: 16.221,
    height: 1.298,
    rx: 0.649,
    transform: "matrix(.8594 .5113 0 1 487.507 109.252)",
    fill: "#8A9EA0"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M346.356 48.434c-7.099-4.035-13.777-2.862-16.362 3.668-1.73-1.896-3.597-3.408-5.46-4.468-2.023-1.148-4.042-1.765-5.893-1.752-3.562.02-6.103 2.353-6.898 6.328a24.484 24.484 0 0 0-3.152-2.15c-4.854-2.76-9.208-2.774-12.142-.561l-12.952 7.477 4.743 8.216 4.63-2.673c1.36 9.148 7.827 19.162 15.619 23.591l53.585 30.462c.102.058.203.114.305.169l-7.038 4.063 2.833 4.906 13.681-7.899a6.912 6.912 0 0 0 1.015-.586l.771-.446-.067-.116c1.83-1.658 2.939-4.388 2.998-8.008.146-8.87-6.071-19.81-13.969-24.584 3.304-8.34-1.321-22.257-10.326-31.083-1.955-1.918-3.955-3.436-5.921-4.554Z",
    fill: "url(#signuphero_svg__k)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "m295.054 93.859.282-.495c-4.301-2.45-8.22-6.665-11.061-11.52-2.841-4.854-4.574-10.296-4.56-15.166.013-4.87 1.762-8.139 4.421-9.633 2.662-1.496 6.435-1.324 10.739 1.127a23.889 23.889 0 0 1 3.083 2.108l.731.584.183-.917c.38-1.903 1.168-3.368 2.243-4.357 1.07-.984 2.459-1.528 4.112-1.537 1.728-.012 3.653.566 5.618 1.684 1.808 1.03 3.632 2.509 5.331 4.373l.615.675.335-.85c1.231-3.114 3.406-4.904 6.087-5.468 2.708-.57 6.015.093 9.492 2.073 1.922 1.095 3.885 2.587 5.814 4.482 4.442 4.362 7.808 9.99 9.654 15.554 1.849 5.578 2.146 11.014.559 15.027l-.177.447.412.25c3.854 2.334 7.326 6.196 9.817 10.588 2.492 4.393 3.972 9.263 3.901 13.588-.07 4.325-1.667 7.203-4.051 8.507-2.39 1.308-5.765 1.143-9.621-1.046l-53.959-30.078Zm0 0 .282-.495 53.677 30.572-53.959-30.077Z",
    fill: "#284D68",
    stroke: "url(#signuphero_svg__l)",
    strokeWidth: 1.139
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M330.083 97.46c-2.064-1.173-3.742-.232-3.749 2.102-.007 2.335 1.662 5.175 3.724 6.35 2.061 1.172 3.739.231 3.746-2.103.007-2.333-1.659-5.178-3.721-6.35ZM319.363 91.367c-2.064-1.173-3.739-.231-3.746 2.102-.007 2.336 1.659 5.176 3.723 6.348 2.062 1.173 3.74.231 3.747-2.102.004-2.334-1.662-5.176-3.724-6.348ZM308.645 85.275c-2.061-1.173-3.739-.23-3.746 2.102-.007 2.335 1.659 5.176 3.721 6.348 2.064 1.172 3.74.233 3.746-2.102.007-2.334-1.657-5.176-3.721-6.349ZM319.426 70.146c-2.064-1.173-3.74-.234-3.747 2.102-.007 2.333 1.66 5.176 3.724 6.348 2.061 1.172 3.739.229 3.746-2.102.005-2.334-1.662-5.176-3.723-6.348Z",
    fill: "#EBFAFD"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M308.706 64.053c-2.062-1.172-3.74-.233-3.747 2.103-.005 1.817 1.005 3.937 2.423 5.343l-.01 2.833c-1.422-.21-2.44.758-2.445 2.573-.007 2.336 1.662 5.176 3.723 6.349 2.064 1.172 3.74.233 3.747-2.103.004-1.815-1.005-3.935-2.423-5.34l.009-2.834c.26.036.508.038.736 0l5.137 8.762a3.59 3.59 0 0 0-.209 1.257c-.007 2.335 1.659 5.175 3.723 6.348 2.062 1.172 3.74.233 3.747-2.103a5.679 5.679 0 0 0-.157-1.31l5.241-2.94c.195.244.402.475.621.692l-.01 2.834c-1.422-.21-2.443.756-2.448 2.57-.006 2.336 1.662 5.177 3.724 6.349 2.064 1.172 3.74.233 3.746-2.103.005-1.815-1.004-3.935-2.424-5.34l.009-2.834c1.422.21 2.443-.756 2.448-2.573.006-2.336-1.66-5.176-3.724-6.348-2.062-1.172-3.739-.233-3.746 2.102-.003.457.064.933.181 1.412l-5.201 2.918c-.575-.736-1.25-1.363-1.981-1.777-.683-.387-1.32-.539-1.871-.491l-5.241-8.935c.092-.314.145-.668.145-1.066.007-2.333-1.659-5.176-3.723-6.348Z",
    fill: "#EBFAFD"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "m30.414 135.902 77.999 45.033a17.287 17.287 0 0 0 16.834.252l153.567-82.62M186.536 218.913v-19.528a17.286 17.286 0 0 1 8.643-14.97l117.835-68.033M272.241 56.028l-17.821-10.29a17.286 17.286 0 0 0-16.15-.6l-85.211 41.079",
    stroke: "#71D5E3",
    strokeWidth: 1.08
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 272.281,
    cy: 55.635,
    r: 1.752,
    fill: "#0A5866"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.416,
    cy: 135.641,
    r: 1.752,
    fill: "#0A5866"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 279.051,
    cy: 98.715,
    r: 1.752,
    fill: "#0A5866"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M295.073 107.905 92.483 224.87a17.285 17.285 0 0 1-17.098.107L54.58 213.311",
    stroke: "#71D5E3",
    strokeWidth: 1.08
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 61.188,
    cy: 210.108,
    r: 1.752,
    fill: "#0A5866"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 295.052,
    cy: 107.331,
    r: 1.752,
    fill: "#0A5866"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 295.052,
    cy: 107.331,
    r: 1.752,
    fill: "#0A5866"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 312.9,
    cy: 116.562,
    r: 1.752,
    fill: "#0A5866"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 186.736,
    cy: 218.724,
    r: 1.752,
    fill: "#0A5866"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 154.118,
    cy: 85.791,
    r: 1.752,
    fill: "#0A5866"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M501.972 204.355a3.036 3.036 0 1 0 6.074 0 3.037 3.037 0 0 0-6.074 0Zm-24.194 44.042-.303.482.303-.482Zm-135.289-95.616v-25.662h-1.139v25.662h1.139Zm135.593 95.134-127.347-80.196-.607.964 127.347 80.196.607-.964Zm28.193-15.403-.697-28.171-1.138.028.697 28.171 1.138-.028Zm-28.8 16.367c12.691 7.992 29.172-1.373 28.8-16.367l-1.138.028c.348 14.085-15.133 22.883-27.055 15.375l-.607.964ZM341.35 152.781a18.791 18.791 0 0 0 8.778 15.902l.607-.964a17.652 17.652 0 0 1-8.246-14.938h-1.139Z",
    fill: "url(#signuphero_svg__m)"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 341.825,
    cy: 127.025,
    r: 1.752,
    fill: "#0A5866"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "m128.913 70.244-1.402.95-8.475 9.24 14.401 7.848 7.264-4.114v-7.405l-11.788-6.52Z",
    fill: "#308484"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "m111.39 85.814 27.272-26.393 13.191 7.595L124.58 93.41l-13.19-7.595Z",
    fill: "#fff"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "m111.963 86.13 27.336-26.33 11.916 6.836-27.272 26.33-11.98-6.836Z",
    fill: "#73D1DD"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "m139.236 59.864.063-.063 11.916 6.835-.063.064-11.916-6.836ZM129.869 68.915l.127-.127 11.916 6.899-.127.063-11.916-6.835ZM120.438 78.029l.064-.063 11.916 6.835-.064.063-11.916-6.835Z",
    fill: "#fff"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "m111.963 86.13 27.336-26.33.319.19-27.336 26.33-.319-.19Z",
    fill: "#7EE0E0"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "m115.595 88.219 27.273-26.393.127.127-27.272 26.329-.128-.063ZM119.546 90.497l27.273-26.392.191.126-27.273 26.33-.191-.064Z",
    fill: "#fff"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M151.853 67.016v.506l-27.146 26.266-.127-.38 27.273-26.392ZM111.389 85.814l13.191 7.595.127.38-13.126-7.532-.192-.443Z",
    fill: "#7EE0E0"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "m142.549 78.092-1.465.95-8.475 9.24 14.465 7.848 7.264-4.114v-7.405l-11.789-6.519Z",
    fill: "#308484"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "m125.026 93.662 27.209-26.393 13.19 7.532-27.209 26.456-13.19-7.595Z",
    fill: "#fff"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "m125.599 93.978 27.337-26.33 11.916 6.836-27.337 26.329-11.916-6.835Z",
    fill: "#73D1DD"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "m152.808 67.712.128-.063 11.916 6.835-.064.064-11.98-6.836ZM143.505 76.763l.064-.127 11.979 6.836-.127.126-11.916-6.835ZM134.011 85.877l.127-.064 11.916 6.836-.127.063-11.916-6.835Z",
    fill: "#fff"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "m125.599 93.978 27.337-26.33.255.19-27.273 26.33-.319-.19Z",
    fill: "#7EE0E0"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "m129.232 96.067 27.209-26.393.191.127-27.273 26.329-.127-.063ZM133.182 98.345l27.273-26.392.127.126-27.272 26.33-.128-.064Z",
    fill: "#fff"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M165.425 74.8v.57l-27.145 26.266-.064-.379 27.209-26.456ZM125.026 93.662l13.19 7.595.064.379-13.063-7.531-.191-.443Z",
    fill: "#7EE0E0"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "m156.122 85.94-1.402.95-8.475 9.24 14.465 7.848 7.264-4.114V92.46l-11.852-6.519Z",
    fill: "#308484"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "m138.599 101.51 27.272-26.393 13.191 7.532-27.273 26.456-13.19-7.595Z",
    fill: "#fff"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "m139.236 101.826 27.272-26.329 11.98 6.835-27.336 26.33-11.916-6.836Z",
    fill: "#73D1DD"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "m166.445 75.56.063-.063 11.98 6.835-.127.064-11.916-6.836ZM157.078 84.611l.127-.126 11.916 6.835-.064.127-11.979-6.836ZM147.647 93.725l.064-.063 11.979 6.835-.127.063-11.916-6.835Z",
    fill: "#fff"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "m139.236 101.826 27.272-26.329.319.19-27.336 26.329-.255-.19Z",
    fill: "#7EE0E0"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "m142.804 103.915 27.273-26.393.127.127-27.272 26.329-.128-.063ZM146.819 106.193l27.209-26.392.191.126-27.273 26.33-.127-.064Z",
    fill: "#fff"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M179.062 82.649v.57l-27.146 26.265-.127-.379 27.273-26.456ZM138.599 101.51l13.19 7.595.127.379-13.126-7.531-.191-.443Z",
    fill: "#7EE0E0"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "m169.758 93.788-1.465.95-8.412 9.24 14.401 7.848 7.265-4.114v-7.405l-11.789-6.519Z",
    fill: "#1A92A8"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "m152.235 109.358 27.273-26.393 13.19 7.532-27.273 26.456-13.19-7.595Z",
    fill: "#fff"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "m152.808 109.674 27.337-26.329 11.916 6.836-27.273 26.329-11.98-6.836Z",
    fill: "#73D1DD"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "m180.081 83.409.064-.064 11.916 6.836-.064.063-11.916-6.835ZM170.714 92.46l.127-.127 11.916 6.835-.127.126-11.916-6.835ZM161.22 101.573l.127-.063 11.916 6.835-.064.063-11.979-6.835Z",
    fill: "#fff"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "m152.808 109.674 27.337-26.329.318.19-27.336 26.329-.319-.19Z",
    fill: "#7EE0E0"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "m156.441 111.763 27.272-26.392.128.126-27.273 26.329-.127-.063ZM160.391 114.041l27.273-26.392.127.127-27.209 26.329-.191-.064Z",
    fill: "#fff"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M192.698 90.497v.57l-27.145 26.266-.128-.38 27.273-26.456Z",
    fill: "#ACEEEE"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "m152.235 109.358 13.19 7.595.128.38-13.127-7.532-.191-.443Z",
    fill: "#7EE0E0"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "m170.587 107.333.573.316v.57l-8.029 7.721-10.769-6.202-.191-.38 6.563-6.392-.127-.064-6.754 6.583-2.231-1.266 8.348-8.102.637.38 11.98 6.836Zm-40.208-22.659v-.57l-.574-.316-10.195-5.822-8.22 7.848.191.38 10.769 6.202 8.029-7.722Zm13.572 7.848v-.57l-.573-.316-11.916-6.898-.637-.38-8.412 8.101 2.231 1.266 6.754-6.582.127.063-6.499 6.456.191.38 10.769 6.202 7.965-7.722Zm13.636 7.849v-.57l-.573-.317-11.98-6.898-.637-.38-8.347 8.101 2.23 1.266 6.754-6.582.128.063-6.563 6.456.191.38 10.769 6.202 8.028-7.721Z",
    fill: "#308484"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "m101.576 87.396-1.401.95-8.475 9.24 14.401 7.848 7.264-4.177v-7.405l-11.789-6.456Z",
    fill: "#308484"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "m84.053 102.965 27.273-26.392 13.19 7.532-27.273 26.392-13.19-7.532Z",
    fill: "#fff"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "m84.627 103.282 27.336-26.392 11.916 6.898-27.273 26.329-11.98-6.835Z",
    fill: "#73D1DD"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "m111.899 77.016.064-.126 11.916 6.898-.064.064-11.916-6.836ZM102.532 86.067l.128-.127 11.916 6.836-.128.126-11.916-6.835ZM93.038 95.18l.127-.126 11.916 6.836-.064.126-11.98-6.835Z",
    fill: "#fff"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "m84.627 103.282 27.336-26.392.319.19-27.337 26.392-.318-.19Z",
    fill: "#7EE0E0"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "m88.259 105.307 27.272-26.329.128.063-27.273 26.393-.127-.127ZM92.21 107.649l27.272-26.392.128.063-27.21 26.392-.19-.063Z",
    fill: "#fff"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M124.516 84.105v.57l-27.145 26.202-.127-.38 27.272-26.392ZM84.053 102.966l13.19 7.531.128.38-13.127-7.532-.19-.379Z",
    fill: "#7EE0E0"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "m115.213 95.244-1.466.95-8.475 9.24 14.465 7.848 7.264-4.177V101.7l-11.788-6.456Z",
    fill: "#308484"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "m97.69 110.814 27.209-26.393 13.19 7.532-27.209 26.392-13.19-7.531Z",
    fill: "#fff"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M98.263 111.13 125.6 84.738l11.915 6.835-27.336 26.393-11.916-6.836Z",
    fill: "#73D1DD"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "m125.472 84.864.128-.126 11.915 6.835-.063.127-11.98-6.836ZM116.169 93.915l.063-.127 11.98 6.836-.127.126-11.916-6.835ZM106.674 103.029l.128-.127 11.916 6.836-.128.126-11.916-6.835Z",
    fill: "#fff"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M98.263 111.13 125.6 84.738l.254.19-27.272 26.392-.319-.19Z",
    fill: "#7EE0E0"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "m101.831 113.155 27.273-26.329.191.063-27.272 26.393-.192-.127ZM105.846 115.497l27.273-26.392.127.063-27.273 26.392-.127-.063Z",
    fill: "#fff"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M138.089 91.953v.57l-27.145 26.202-.064-.38 27.209-26.392ZM97.69 110.814l13.19 7.531.064.38-13.127-7.532-.127-.379Z",
    fill: "#7EE0E0"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "m128.785 103.092-1.401.949-8.475 9.241 14.401 7.848 7.328-4.177v-7.405l-11.853-6.456Z",
    fill: "#308484"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "m111.262 118.662 27.273-26.393 13.19 7.532-27.272 26.392-13.191-7.531Z",
    fill: "#fff"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "m111.899 118.978 27.273-26.392 11.98 6.835-27.337 26.393-11.916-6.836Z",
    fill: "#73D1DD"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "m139.108 92.712.064-.126 11.98 6.835-.128.127-11.916-6.836ZM129.741 101.7l.128-.064 11.916 6.836-.064.126-11.98-6.898ZM120.311 110.877l.063-.127 11.98 6.836-.127.126-11.916-6.835Z",
    fill: "#fff"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "m111.899 118.978 27.273-26.392.319.19-27.337 26.392-.255-.19Z",
    fill: "#7EE0E0"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "m115.468 121.003 27.272-26.329.128.064-27.273 26.392-.127-.127ZM119.482 123.345l27.209-26.392.191.063-27.272 26.393-.128-.064Z",
    fill: "#fff"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M151.725 99.8v.571l-27.145 26.202-.127-.38 27.272-26.392ZM111.262 118.662l13.191 7.531.127.38-13.127-7.532-.191-.379Z",
    fill: "#7EE0E0"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "m142.422 110.94-1.466.95-8.411 9.24 14.401 7.848 7.264-4.177v-7.405l-11.788-6.456Z",
    fill: "#1A92A8"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "m124.898 126.51 27.273-26.393 13.19 7.532-27.272 26.392-13.191-7.531Z",
    fill: "#fff"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "m125.472 126.826 27.337-26.392 11.915 6.835-27.272 26.393-11.98-6.836Z",
    fill: "#73D1DD"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "m152.681 100.56.127-.126 11.916 6.835-.063.127-11.98-6.836ZM143.378 109.548l.063-.064 11.98 6.836-.127.126-11.916-6.898ZM133.883 118.725l.128-.127 11.916 6.836-.064.126-11.98-6.835Z",
    fill: "#fff"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "m125.472 126.826 27.337-26.392.318.19-27.336 26.392-.319-.19Z",
    fill: "#7EE0E0"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "m129.104 128.852 27.273-26.33.127.064-27.272 26.392-.128-.126ZM133.055 131.193l27.273-26.392.127.063-27.273 26.393-.127-.064Z",
    fill: "#fff"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M165.362 107.649v.57l-27.146 26.202-.127-.38 27.273-26.392Z",
    fill: "#7EE0E0"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "m124.899 126.51 13.19 7.531.127.38-13.126-7.531-.191-.38Z",
    fill: "#7EE0E0"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M44.998 259.152c19.693 0 35.658-4.015 35.658-8.969 0-4.953-15.965-8.968-35.658-8.968S9.34 245.23 9.34 250.183c0 4.954 15.965 8.969 35.658 8.969Z",
    fill: "url(#signuphero_svg__n)",
    opacity: 0.5
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M65.164 202.113c-4.296-2.497-9.79-3.297-14.086-.849l-20.78 11.189c-1.199.7-3.497 7.393-2.598 7.893l5.895 3.396c.899.5 12.488-.799 13.687-1.498l19.331-11.989c4.246-2.497 2.847-5.644-1.449-8.142Z",
    fill: "#2798AD"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "m47.282 222.244 19.331-11.989c4.246-2.447 2.847-5.644-1.448-8.142-1.599-.899-3.297-1.598-5.096-1.998-5.894 1.748-11.339 3.347-11.339 3.347L33.795 216.1v7.692c1.898.3 12.338-.899 13.487-1.548Z",
    fill: "#0B8BA2"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 216.549v3.247l1.899 1.299.699-3.697-2.598-.849Z",
    fill: "#2798AD"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "m49.38 186.578-4.246-.1v.849c0 .45.15.949.4 1.299l11.089 15.635 3.896-.899-11.14-16.784Z",
    fill: "#0B8BA2"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M49.53 187.177v1.399l1.048-.25-.849-1.248-.2.099ZM50.628 188.676v1.449l1.05-.3-.85-1.199-.2.05Z",
    fill: "#2798AD"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "m60.12 203.162-1.55 2.248 28.124 6.644 1.548-2.248v-1.549l-8.092-1.748-20.03-3.347Z",
    fill: "#0B8BA2"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M81.15 206.909v1.948l.948.249 1.3-1.798-2.349-.649.1.25ZM83.847 207.558v1.898l.899.25 1.298-1.749-2.347-.649.15.25Z",
    fill: "#2798AD"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M67.862 206.059v1.599l-3.447.899-.899-2.298 4.346-.949v.749ZM12.715 206.759l-.5.699c-.05.05-.05.15-.1.2l-.949-.2v.699c0 .5.35.899.8 1.049l.998.25 26.325 6.194 1.549-2.248-28.123-6.643Zm6.643 1.998-.3.449-1.698-.399.35-.5 1.648.45Zm-4.345-1.049 1.698.399-.35.5-1.698-.4.35-.499Z",
    fill: "#0B8BA2"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M15.012 206.159v1.549l-.35.449-.798-.399 1.148-1.599Z",
    fill: "#0B8BA2"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M15.012 207.708v-1.549l4.346.999-.233 1.549-4.113-.999Z",
    fill: "#2798AD"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M17.66 206.705v1.652l-.3.45-1.005-.408 1.305-1.694ZM51.028 231.535l2.547-.6c.45-.099.75-.499.75-.899v-.799l-11.49-14.686-3.895.899 11.139 15.735c.15.25.55.4.949.35Z",
    fill: "#0B8BA2"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M50.878 225.391v1.298l.7-.149.15-.2-.85-.949ZM51.927 226.889v1.349l.75-.15.15-.2-.9-.999Z",
    fill: "#01869E"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "m49.03 185.579-3.896.899 11.489 16.235 3.896-.9-11.489-16.234Zm-2.248 2.248 2.748-.65.699.999-2.748.65-.699-.999Zm1.749 2.497-.7-.999 2.747-.649.7.999-2.747.649Z",
    fill: "#284D68"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "m60.12 201.614-1.55 2.247 28.124 6.644 1.548-2.248-28.123-6.643Zm22.578 7.542 1.099-1.598 1.698.399-1.099 1.599-1.698-.4Zm-1.549-2.248 1.698.4-1.098 1.599-1.699-.4 1.1-1.599Z",
    fill: "#284D68"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M68.012 207.608v-1.449s1.199-.899 1.199-2.398c0-1.498-3.097 2.098-3.097 2.098l1.898 1.749Z",
    fill: "#0B8BA2"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "m39.29 214.102 1.548-2.248-28.123-6.644-1.549 2.248 28.123 6.644Zm-22.58-7.543-1.098 1.598-1.698-.399 1.099-1.599 1.698.4Zm1.5 2.198-1.699-.4 1.1-1.598 1.697.399-1.099 1.599Z",
    fill: "#284D68"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M14.313 206.559v-3.846h-2.248v3.796c0 .2.1.35.35.499.45.25 1.149.25 1.599 0 .2-.099.3-.249.3-.449ZM48.68 186.678v-3.846h-2.248v3.796c0 .2.1.35.35.499.45.25 1.149.25 1.599 0 .2-.099.3-.299.3-.449Z",
    fill: "#0688A0"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M48.33 183.881c-.449.249-1.148.249-1.598 0-.45-.25-.45-.65 0-.9.45-.249 1.15-.249 1.599 0 .45.25.45.65 0 .9Z",
    fill: "#0E8CA3"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M87.493 209.007v-3.847h-2.248v3.797c0 .199.1.349.35.499.45.25 1.149.25 1.598 0 .2-.1.35-.3.3-.449Z",
    fill: "#0688A0"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M87.193 205.66c-.45.249-1.149.249-1.598 0-.45-.25-.45-.65 0-.899.45-.25 1.149-.25 1.598 0 .4.249.4.649 0 .899Z",
    fill: "#0E8CA3"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "m50.379 230.086 3.896-.899-11.489-16.234-3.896.899 11.489 16.234Zm2.248-2.198-2.748.65-.7-.999 2.748-.65.7.999Zm-1.749-2.497.7.999-2.748.649-.7-.999 2.748-.649Z",
    fill: "#284D68"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "m47.331 219.297-3.996.749v1.598l-2.497-1.548-.05-1.299 6.344-.899.2 1.399Z",
    fill: "#0B8BA2"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M52.676 228.738v-3.847H50.43v3.797c0 .199.1.349.35.499.449.25 1.148.25 1.598 0 .2-.1.3-.25.3-.449Z",
    fill: "#0688A0"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M52.327 225.391c-.45.25-1.15.25-1.599 0-.45-.25-.45-.65 0-.899.45-.25 1.15-.25 1.599 0 .45.249.45.649 0 .899Z",
    fill: "#0E8CA3"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M65.164 198.766c-4.296-2.497-9.79-3.297-14.086-.849l-20.78 11.189c-1.199.7-3.497 7.393-2.598 7.893l5.895 3.397c.899.499 12.488-.8 13.687-1.499l19.331-11.988c4.246-2.498 2.847-5.695-1.449-8.143Z",
    fill: "#8AC7D2"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "m61.568 196.618 4.046 2.448-.65 1.798-3.796-2.797.4-1.449Z",
    fill: "#9ED1DA"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "m31.197 207.358-1.61 2.58 1.36 1.117 2.298-3.147-2.048-.55Z",
    fill: "#8AC7D2"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M61.668 196.668c-3.097-1.798-8.642-1.548-12.288.6l-17.783 9.69c-1.05.6-3.647 8.942-2.998 9.291l4.247 2.448c.649.35 9.99-4.046 11.039-4.645l16.734-10.291c3.696-2.098 4.146-5.295 1.049-7.093Z",
    fill: "#C2E2E8"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M30.148 209.756c-.3.999-.6 1.998-.85 2.997-.249.999-.499 2.048-.549 2.997v.3l-.05-.05h.05l.15.1.7.399 1.348.75 1.349.749.7.399c-.1-.049 0 0 .1-.049.1-.05.199-.05.349-.1 1.898-.65 3.796-1.549 5.644-2.398.95-.45 1.899-.849 2.798-1.299.45-.2.949-.449 1.398-.699l.3-.15.35-.2.65-.399c3.546-2.148 7.092-4.296 10.689-6.394l5.345-3.147c.899-.5 1.698-1.099 2.298-1.948.599-.8.899-1.899.549-2.898.2.5.3.999.2 1.549-.05.549-.3 1.049-.55 1.498-.55.9-1.398 1.599-2.297 2.198l-5.245 3.347a462.965 462.965 0 0 1-10.54 6.594l-.65.399-.35.2-.349.2c-.45.25-.95.45-1.399.699-.949.45-1.898.899-2.847 1.299-.949.45-1.898.849-2.847 1.249-.95.4-1.898.799-2.947 1.099-.15.05-.25.05-.4.1-.1 0-.15.05-.25.05h-.15c-.05 0-.1 0-.15-.05l-.05-.05-.649-.4-1.348-.799-1.35-.799-.649-.4-.15-.1-.05-.05c-.05-.05-.1-.05-.1-.1-.05-.05-.05-.149-.1-.199-.05-.2-.05-.35 0-.5.15-1.099.45-2.048.75-3.047.3-.999.7-1.948 1.099-2.897 0 0 .05-.05.05 0v-.05Z",
    fill: "#DBEEF1"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "m56.573 201.414-4.046-2.298.25-.699-2.948.449-1.448 3.147 3.996 2.348 5.494-.849.8-1.749-2.098-.349Z",
    fill: "#01869E"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M49.63 202.763c1.498-.45 3.946-1.199 6.093-1.799l-1.248-.699a364.698 364.698 0 0 0-6.094 1.798l1.248.7ZM57.572 201.614l-.95-.15-6.193 1.748.45.25 6.693-1.848Z",
    fill: "#C2E2E8"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "m46.732 184.73-.1-.75 2.947-.149 3.847-.2 5.794-.3c.45 0 .8-.25.8-.549-.05-.25-.35-.4-.75-.45l-9.79-.749c-.55-.05-1 .2-.95.549l.1.75-2.897.149h-.05l-9.59.45c-.45 0-.8.25-.8.549.05.25.35.4.75.45l9.79.749c.45.1.949-.2.899-.499ZM84.246 204.411l1.299.1-.3 1.698-.4 2.198-.599 3.347c-.05.25.3.499.75.549.399 0 .799-.1.898-.349l3.098-5.395c.15-.3-.2-.6-.75-.649l-1.299-.1.3-1.649v-.05l.95-5.544c.05-.25-.3-.5-.75-.55-.4-.05-.8.1-.9.35l-3.096 5.395c-.1.299.25.599.8.649ZM49.33 225.591l1.298.05.25-1.699.3-2.198.5-3.347c.05-.249.449-.449.948-.449.4 0 .75.2.8.449l1.348 5.645c.05.3-.4.599-.899.55l-1.299-.05-.25 1.648v.05l-.799 5.545c-.05.249-.45.449-.949.449-.4 0-.749-.2-.799-.449l-1.349-5.645c-.1-.3.35-.549.9-.549ZM14.563 204.011l-.15-.749-2.947.15-3.796.2-5.745.349c-.45.05-.9-.15-.949-.449-.05-.25.2-.45.6-.5l9.34-1.798c.5-.1 1.05.1 1.15.4l.15.749 2.847-.15h.05l9.59-.549c.45-.05.9.149.95.449.05.25-.2.45-.6.5l-9.341 1.798c-.5.1-1.05-.1-1.149-.4Z",
    fill: "#64B5C4"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "m46.732 184.38-.1-.749 2.947-.15 3.847-.2 5.794-.3c.45 0 .8-.249.8-.549-.05-.25-.35-.4-.75-.45l-9.79-.749c-.55-.05-1 .2-.95.55l.1.749-2.897.15h-.05l-9.59.449c-.45 0-.8.25-.8.55.05.25.35.399.75.449l9.79.75c.45.1.949-.15.899-.5Z",
    fill: "#C2E2E8"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M47.98 183.381c-.249.15-.698.15-.948 0s-.25-.399 0-.549c.25-.15.699-.15.949 0s.25.399 0 .549Z",
    fill: "#0E8CA3"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "m84.246 204.111 1.299.1-.3 1.698-.4 2.198-.599 3.347c-.05.25.3.5.75.55.399 0 .799-.1.898-.35l3.098-5.395c.15-.3-.2-.599-.75-.649l-1.299-.1.3-1.649v-.05l.95-5.544c.05-.25-.3-.5-.75-.55-.4 0-.8.1-.9.35l-3.096 5.395c-.1.3.25.599.8.649ZM49.33 225.291l1.298.05.25-1.699.3-2.197.5-3.347c.05-.25.449-.45.948-.45.4 0 .75.2.8.45l1.348 5.644c.05.3-.4.6-.899.55l-1.299-.05-.25 1.648v.05l-.799 5.545c-.05.25-.45.45-.949.45-.4 0-.749-.2-.799-.45l-1.349-5.645c-.1-.299.35-.599.9-.549ZM14.563 203.662l-.15-.75-2.947.15-3.796.2-5.745.35c-.45.05-.9-.15-.949-.45-.05-.25.2-.45.6-.499l9.34-1.799c.5-.1 1.05.1 1.15.4l.15.749 2.847-.15h.05l9.59-.549c.45-.05.9.15.95.449.05.25-.2.45-.6.5l-9.341 1.798c-.5.15-1.05-.05-1.149-.399Z",
    fill: "#C2E2E8"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M31.497 220.795c0 .699-.5.999-1.1.65-.599-.35-1.098-1.199-1.098-1.949 0-.699.5-.999 1.099-.649.6.4 1.099 1.249 1.099 1.948Z",
    fill: "#0688A0"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M31.147 220.645c0 .5-.35.7-.8.45-.449-.25-.798-.849-.798-1.399 0-.549.35-.699.799-.449.45.249.799.899.799 1.398Z",
    fill: "#01869E"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M30.648 220.296c0 .15-.1.249-.25.15-.15-.1-.25-.3-.25-.45 0-.15.1-.25.25-.15.1.1.25.3.25.45Z",
    fill: "#0688A0"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M48.38 202.063c-.05 0-.05 0 0 0-.1-.05-.1-.1-.05-.1l1.45-3.147c0-.05.05-.05.05-.05l2.996-.449c.05 0 .1 0 .1.05s0 .1-.05.1l-2.947.449-1.449 3.097c-.05.05-.1.05-.1.05ZM58.67 201.863s-.05 0 0 0l-2.047-.349h-.05l-4.096-2.348c-.05 0-.05-.05-.05-.1s.05-.05.1-.05l4.046 2.348 1.998.35c.05 0 .05.049.05.099.1.05.05.05.05.05Z",
    fill: "#DBEEF1"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M13.664 202.812c-.25.15-.7.15-1 0-.299-.149-.299-.399 0-.599.25-.15.7-.15 1 0 .3.15.3.4 0 .599ZM52.027 225.091c-.25.15-.65.15-.9 0-.249-.15-.249-.4 0-.549.25-.15.65-.15.9 0 .25.199.25.399 0 .549ZM86.744 205.16c-.25.15-.65.15-.9 0s-.25-.399 0-.549c.25-.15.65-.15.9 0s.3.399 0 .549Z",
    fill: "#0E8CA3"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#signuphero_svg__o)"
  }, _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M265.606 225.469v-2.415l-21.229 12.299v2.583l21.229-12.467Z",
    fill: "#5AB5BC"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "m244.377 235.353-8.086-4.605v2.583l8.086 4.605v-2.583Z",
    fill: "#92CBD5"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "m265.606 223.054-21.229 12.299-8.086-4.605 17.634-14.601 11.681 6.907Z",
    fill: "#DAE7E8"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "m244.097 232.657 19.094-11.231-6.571-3.763-19.094 11.232 6.571 3.65v.112ZM244.097 193.851l19.094-11.063-6.571-3.763-19.094 11.064 6.571 3.762Z",
    fill: "#ABD7DF"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M261.45 219.797v2.134l-16.567 9.716v-2.135l16.567-9.715Z",
    fill: "#5AB5BC"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M244.883 229.512v2.135l-5.672-3.258v-2.134l5.503 3.089.169.168Z",
    fill: "#209BA5"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "m244.097 232.657 19.094-11.231v1.46l-19.094 11.063v-1.46.168ZM244.097 193.851l-2.527-1.46 2.302 37.402.281.113 19.094-11.064v-36.054l-19.15 11.063Zm9.828 14.602v2.695l-1.067.562-2.022 1.067V199.13l3.089-1.741v11.064Z",
    fill: "#DBEEF1"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "m253.363 188.741-.786 4.998 1.46-.674v2.583l1.067-4.436-1.629.674-.112-3.145Z",
    fill: "#5AB5BC"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M244.097 232.489V233.949l-6.571-3.763v-1.347l6.571 3.65ZM241.682 192.503l2.415 1.348v36.223l-.281-.112-6.346-3.651v-36.222l4.212 2.414Z",
    fill: "#8AC7D2"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M261.45 181.159v2.134l-16.567 9.604v-2.134l16.567-9.604Z",
    fill: "#5AB5BC"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M244.883 190.763v2.134l-5.672-3.258v-2.134l5.503 3.089.169.169Z",
    fill: "#209BA5"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M263.191 177.509v2.696l-19.094 11.063-2.696-1.46-.112-3.257 2.976-3.089 12.355-13.366c0-.786.393-1.46.955-1.91l.393-.28c.674-.281 1.46-.281 2.134.112 2.808 1.629 2.696 2.696 2.808 4.998.112 1.516.281 2.864.281 4.493Z",
    fill: "#DBEEF1"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "m262.91 172.679-10.783 6.234-10.501 6.234-2.808-5.953 18.701-10.951.393-.281c.674-.281 1.46-.281 2.134.112 2.19 1.179 2.864 2.303 2.864 4.605Z",
    fill: "#EBF5F7"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M244.097 188.741v2.583l-2.696-1.46-3.875-2.134v-6.571c0-1.741 1.909-2.976 3.482-2.021 2.302 1.347 2.976 2.583 3.089 4.211.28 1.461 0 3.089 0 5.392Z",
    fill: "#8AC7D2"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M253.925 208.453v-11.064l-2.977 1.741v13.759l1.91-1.067-1.91 6.346-.561-.393v-18.926l7.132-4.211.561.28-4.155 13.535Z",
    fill: "#209BA5"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M258.08 194.918v19.038l-7.132 4.212v-5.279l1.91-1.067 1.067-.561v-13.872l4.155-2.471Z",
    fill: "#5AB5BC"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "m250.387 198.849.561.281 7.132-4.212-.561-.28-7.132 4.211Z",
    fill: "#94CFD4"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M258.08 194.918v19.038l-4.155-2.695v-13.872l4.155-2.471ZM239.941 213.732c.674.112 1.348 0 2.022-.113.28-.954.393-1.741.393-2.695 0-1.348-1.348-2.134-2.527-2.022-1.348.112-1.067 1.629-1.348 2.696-.113.954-.562 1.067-1.236 1.46a6.297 6.297 0 0 0-1.628 2.022c-.281.561-.394 1.067-.674 1.74-.674 2.303-1.067 4.718-1.236 7.189 0 .561 0 .955-.281 1.46-.28 1.067-1.628 1.741-2.976 1.741s-2.527-.393-3.875-.674c-.393-.112-.955-.112-1.46-.112-.562.112-.955.393-1.067.786-.113.281-.113.393 0 .674 0 .112.112.112.281.281.393.28.954.393 1.347.561 1.741.281 3.482.674 5.111.113 1.067-.281 2.696-1.067 3.089-2.134 1.067-2.022.954-4.606 1.235-6.74.281-1.347.562-2.976 1.348-4.212 1.011-1.347 1.572-2.583 3.482-2.021Z",
    fill: "#209BA5"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M236.234 255.402c.225-.337 1.011-1.573 1.124-1.966 3.481-14.882-5.448-10.895-22.745-20.273l-4.38 7.076 26.001 15.163Z",
    fill: "#1A92A8"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M236.01 250.235c0-2.415-.899-4.099-2.359-4.773l-4.942-2.696c-1.067-.056-2.864.449-4.212 1.179-4.1 2.359-7.75 6.29-8.48 11.232-.056.281.056 2.864 0 3.37 0 0 .056 0 .056.056l8.031 4.605c1.292.618 2.976.506 4.83-.618 3.875-2.302 7.076-7.806 7.076-12.355Z",
    fill: "#284D68"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M236.01 250.235c0 4.549-3.201 10.053-7.133 12.355-3.931 2.247-7.132.45-7.132-4.099s3.201-10.053 7.132-12.355c3.932-2.303 7.133-.45 7.133 4.099Z",
    fill: "#284D68"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M235.841 250.516c0 4.212-2.976 9.379-6.627 11.513-3.65 2.134-6.626.393-6.626-3.819s2.976-9.379 6.626-11.513c3.651-2.134 6.627-.449 6.627 3.819Z",
    fill: "#0F7482"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M233.82 251.695c0-2.92-2.078-4.099-4.606-2.639-2.527 1.46-4.605 4.998-4.605 7.975 0 2.92 2.078 4.099 4.605 2.639 2.528-1.516 4.606-5.054 4.606-7.975Z",
    fill: "#2899AD"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M232.528 252.426c0-2.135-1.516-2.977-3.314-1.91-1.853 1.067-3.313 3.65-3.313 5.785 0 2.134 1.516 2.976 3.313 1.909 1.854-1.067 3.314-3.65 3.314-5.784Z",
    fill: "url(#signuphero_svg__p)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M229.214 247.877c-3.088 1.797-5.616 6.121-5.616 9.715 0 3.594 2.528 4.998 5.616 3.257 3.089-1.797 5.616-6.121 5.616-9.715 0-3.594-2.527-5.054-5.616-3.257Zm0 11.737c-2.527 1.46-4.549.281-4.549-2.64 0-2.92 2.022-6.402 4.549-7.862 2.528-1.46 4.549-.281 4.549 2.64 0 2.864-2.021 6.402-4.549 7.862Z",
    fill: "#B1DAE1"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M229.214 248.494c-2.808 1.629-5.054 5.56-5.054 8.817 0 3.258 2.303 4.549 5.054 2.921 2.808-1.629 5.055-5.56 5.055-8.817 0-3.258-2.247-4.549-5.055-2.921Zm0 11.457c-2.695 1.572-4.885.281-4.885-2.808s2.19-6.908 4.885-8.424c2.696-1.572 4.886-.281 4.886 2.808s-2.19 6.908-4.886 8.424Z",
    fill: "url(#signuphero_svg__q)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M229.214 247.877c-3.088 1.797-5.616 6.121-5.616 9.715 0 3.594 2.528 4.998 5.616 3.257 3.089-1.797 5.616-6.121 5.616-9.715 0-3.594-2.527-5.054-5.616-3.257Zm5.111 1.684c0 .057 0 .057.056.113a52.627 52.627 0 0 1-2.359 2.19c-1.123 1.011-1.179.898-1.179.898s-.056-.112 1.067-1.179c.786-.786 1.797-1.741 2.303-2.246.056.056.056.168.112.224Zm-3.37-2.078c.45-.056.899-.056 1.292.057.449.112.842.337 1.179.674-2.246 3.762-3.032 3.706-3.088 3.65-.057 0-.731-.281.617-4.381Zm-.393 6.571c-.056.112-.168.281-.224.281-.113 0-.169-.056-.113-.225.056-.112.169-.28.225-.28.112 0 .168.112.112.224Zm-.786-1.292c.056-.112.168-.224.281-.224.112 0 .112.168.056.281-.056.112-.169.224-.281.224-.112 0-.112-.168-.056-.281Zm-.786-4.436c.112-.056.168-.112.281-.169.056 0 .056-.056.112-.056 0 .618 0 1.854-.056 2.864-.056 1.404-.169 1.461-.169 1.461s-.112.056-.168-1.292c.056-1.011 0-2.19 0-2.808Zm.449 7.301c0 .112-.112.28-.225.337-.112.056-.224 0-.224-.113 0-.112.112-.281.224-.337.113-.056.225 0 .225.113Zm-1.067-2.134c.112-.113.225-.169.281-.113.056.056.056.225-.056.337-.113.113-.225.169-.281.113-.056-.057 0-.225.056-.337Zm-2.359-2.247a9.158 9.158 0 0 1 1.517-1.741c1.347 2.471.673 3.538.561 3.651-.112.112-.842 1.067-3.145-.113.281-.561.618-1.179 1.067-1.797Zm2.078 4.381c-.112.112-.224.112-.224 0-.057-.113 0-.281.112-.337.112-.113.224-.113.224 0 .057.056 0 .224-.112.337Zm-3.931-.394c0-.056 0-.112.056-.112a47.835 47.835 0 0 1 2.303-.393c1.123-.168 1.067 0 1.067 0s-.056.112-1.18.449c-.842.225-1.797.45-2.358.506.056-.169.112-.281.112-.45Zm.674 5.223a3.413 3.413 0 0 1-.674-1.179 5.666 5.666 0 0 1-.281-1.741c3.089-2.246 3.426-1.516 3.482-1.404.056.056.225.955-2.527 4.324Zm1.404.73c-.056 0-.169-.056-.225-.056h-.112c.337-.73.955-2.022 1.46-3.145.73-1.46.786-1.46.786-1.46s.113 0-.561 1.516c-.393 1.124-1.011 2.415-1.348 3.145Zm3.089-.73a5.582 5.582 0 0 1-1.629.674c.562-3.875 1.46-4.436 1.573-4.549.112-.056 1.01-.505 1.572 2.808-.505.393-1.011.787-1.516 1.067Zm2.976-2.808-.112.113c-.337-.337-.955-.955-1.404-1.517-.674-.73-.562-.898-.562-.898s.113-.113.786.505c.506.45 1.18 1.067 1.461 1.404a2.804 2.804 0 0 1-.169.393Zm1.236-2.302c-2.752-.169-2.528-1.236-2.528-1.404.057-.169.394-1.292 3.538-2.64 0 .562-.112 1.18-.28 1.854-.113.786-.393 1.516-.73 2.19Z",
    fill: "url(#signuphero_svg__r)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M230.225 253.773c0 .618-.449 1.404-1.011 1.741-.561.337-1.01.056-1.01-.561 0-.618.449-1.404 1.01-1.741.562-.337 1.011-.113 1.011.561Z",
    fill: "url(#signuphero_svg__s)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M229.495 247.708c-.056.056-.112.056-.168.112-.113.057-.225.169-.337.225 0 .618 0 2.359.056 3.707.056 1.572.225 1.516.225 1.516s.168-.112.224-1.741v-3.819Zm-.112 3.201c-.056 1.404-.169 1.46-.169 1.46s-.112.057-.168-1.291c-.056-.955-.056-2.134-.056-2.808.112-.056.168-.113.281-.169.056 0 .056-.056.112-.056.056.674 0 1.853 0 2.864Z",
    fill: "url(#signuphero_svg__t)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M227.024 254.503c-1.123.169-2.583.45-3.089.562 0 .056-.056.168-.056.225-.056.168-.056.28-.112.449.505-.056 1.909-.393 3.089-.674 1.348-.337 1.404-.562 1.404-.562s.112-.168-1.236 0Zm.562.169s-.056.112-1.18.449c-.842.225-1.797.449-2.358.506 0-.113.056-.225.056-.394 0-.056 0-.112.056-.112a47.835 47.835 0 0 1 2.303-.393c1.179-.225 1.123-.056 1.123-.056Z",
    fill: "url(#signuphero_svg__u)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M228.653 255.57s-.112-.056-1.011 1.741c-.786 1.517-1.685 3.482-1.966 4.1.057 0 .113.056.113.056.112 0 .168.056.281.056.336-.674 1.179-2.583 1.853-4.099.842-1.854.73-1.854.73-1.854Zm-1.011 2.471c-.505 1.124-1.067 2.415-1.404 3.145-.056 0-.168-.056-.225-.056h-.112c.337-.73.955-2.022 1.46-3.145.73-1.46.786-1.46.786-1.46s.169 0-.505 1.516Z",
    fill: "url(#signuphero_svg__v)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M230.787 255.514c-.899-.786-1.011-.561-1.011-.561s-.112.168.674 1.067c.674.786 1.572 1.741 1.853 1.965l.169-.168c.112-.112.168-.281.28-.393-.336-.393-1.235-1.292-1.965-1.91Zm1.516 2.134-.112.113c-.337-.337-.955-.955-1.404-1.517-.674-.73-.562-.898-.562-.898s.113-.113.843.505c.505.45 1.179 1.067 1.46 1.404a3.32 3.32 0 0 0-.225.393Z",
    fill: "url(#signuphero_svg__w)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M234.55 249.337c-.057-.113-.057-.225-.113-.281-.505.449-1.909 1.853-3.032 2.976-1.292 1.348-1.236 1.461-1.236 1.461s.056.112 1.404-1.067c1.179-1.067 2.64-2.415 3.089-2.865-.056-.112-.056-.168-.112-.224Zm-2.528 2.527c-1.123 1.011-1.179.898-1.179.898s-.056-.112 1.067-1.179c.786-.786 1.797-1.741 2.303-2.246.056.112.056.168.112.281 0 .056 0 .056.056.112-.562.449-1.572 1.404-2.359 2.134Z",
    fill: "url(#signuphero_svg__x)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M229.383 255.964c.056-.113.112-.225.112-.394 0-.168-.112-.28-.281-.168a.67.67 0 0 0-.28.505c0 .113.056.225.112.225-.281.281-.786 1.348-1.629 5.391a6.436 6.436 0 0 0 1.797-.674c.618-.337 1.236-.842 1.798-1.347-.843-3.145-1.348-3.538-1.629-3.538Zm-.393-.113c0-.112.112-.281.224-.337.113-.056.225 0 .225.113 0 .112-.112.28-.225.337-.112.056-.224 0-.224-.113Zm-1.348 5.279c.562-3.875 1.46-4.436 1.572-4.549.113-.056 1.011-.505 1.573 2.808-.449.45-.955.787-1.46 1.067-.618.337-1.18.562-1.685.674Z",
    fill: "url(#signuphero_svg__y)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M234.83 251.022c-3.201 1.628-3.931 2.471-4.155 2.808 0-.113-.113-.169-.225-.113a.64.64 0 0 0-.393.449c-.056.225.056.337.168.337.113 0 .225-.112.281-.224.056.337.449.898 3.145 1.348.337-.73.618-1.573.842-2.359a8.376 8.376 0 0 0 .337-2.246Zm-4.268 3.032c-.056.112-.168.281-.224.281-.113 0-.169-.056-.113-.225.056-.112.169-.28.225-.28.112 0 .168.112.112.224Zm3.763-.842c-.169.73-.449 1.46-.786 2.19-2.752-.168-2.527-1.236-2.527-1.404.056-.168.393-1.292 3.538-2.64 0 .562-.057 1.18-.225 1.854Z",
    fill: "url(#signuphero_svg__z)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M233.763 247.933a2.684 2.684 0 0 0-1.291-.73 3.954 3.954 0 0 0-1.629 0c-1.123 4.099-1.067 4.998-.955 5.223-.112.056-.168.168-.28.28-.113.225-.057.393.056.45.112.056.337-.113.449-.337.056-.113.056-.281.056-.337.337-.056 1.123-.787 3.594-4.549Zm-3.65 4.886c-.056.112-.168.224-.281.224-.112 0-.112-.168-.056-.281.056-.112.169-.224.281-.224.056 0 .112.168.056.281Zm.842-5.335c.45-.057.899-.057 1.292.056.449.112.842.337 1.179.674-2.246 3.762-3.032 3.706-3.088 3.65-.057 0-.73-.281.617-4.38Z",
    fill: "url(#signuphero_svg__A)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M228.765 253.268c-.056-.056-.168-.056-.281 0 .169-.393.225-1.404-.954-4.156-.562.506-1.124 1.179-1.629 1.91-.505.73-.955 1.46-1.292 2.246 2.471.898 3.258.674 3.595.449-.057.113 0 .225.056.281.112.112.281 0 .449-.168.112-.225.112-.45.056-.562Zm-.674-.056c-.112.112-.842 1.067-3.145-.113.281-.617.674-1.235 1.067-1.797a9.158 9.158 0 0 1 1.517-1.741c1.291 2.471.617 3.482.561 3.651Zm.506.505c-.113.113-.225.169-.281.113-.056-.057-.056-.225.056-.337.112-.113.225-.169.281-.113.056.056.056.225-.056.337Z",
    fill: "url(#signuphero_svg__B)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M228.316 255.177c-.056-.168-.225-.168-.393 0a1.173 1.173 0 0 0-.225.337c-.225-.112-.955-.056-4.156 1.966 0 .674.056 1.348.281 1.909.169.562.506 1.011.843 1.404 2.695-3.538 3.088-4.605 3.144-4.998.057 0 .169 0 .281-.112.225-.113.281-.337.225-.506Zm-3.482 5.279c-.281-.28-.505-.674-.674-1.179a5.666 5.666 0 0 1-.281-1.741c3.089-2.246 3.426-1.516 3.482-1.404.056.056.225.955-2.527 4.324Zm3.257-4.829c-.112.112-.224.112-.224 0-.057-.113 0-.281.112-.337.112-.113.225-.113.225 0 .056.056 0 .224-.113.337Z",
    fill: "url(#signuphero_svg__C)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "signuphero_svg__E",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 228,
    y: 247,
    width: 2,
    height: 7
  }, _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M229.495 247.708c-.056.056-.112.056-.168.112-.113.057-.225.169-.337.225 0 .618 0 2.359.056 3.707.056 1.572.225 1.516.225 1.516s.168-.112.224-1.741v-3.819Zm-.112 3.201c-.056 1.404-.169 1.46-.169 1.46s-.112.057-.168-1.291c-.056-.955-.056-2.134-.056-2.808.112-.056.168-.113.281-.169.056 0 .056-.056.112-.056.056.674 0 1.853 0 2.864Z",
    fill: "url(#signuphero_svg__D)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#signuphero_svg__E)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229.495 247.708c-.056.056-.112.056-.168.112-.113.057-.225.169-.337.225 0 .618 0 2.359.056 3.707.056 1.572.225 1.516.225 1.516s.168-.112.224-1.741v-3.819Zm-.112 3.201c-.056 1.404-.169 1.46-.169 1.46s-.112.057-.168-1.291c-.056-.955-.056-2.134-.056-2.808.112-.056.168-.113.281-.169.056 0 .056-.056.112-.056.056.674 0 1.853 0 2.864Z",
    fill: "url(#signuphero_svg__F)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "signuphero_svg__H",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 223,
    y: 254,
    width: 6,
    height: 2
  }, _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M227.024 254.503c-1.123.169-2.583.45-3.089.562 0 .056-.056.168-.056.225-.056.168-.056.28-.112.449.505-.056 1.909-.393 3.089-.674 1.348-.337 1.404-.562 1.404-.562s.112-.168-1.236 0Zm.562.169s-.056.112-1.18.449c-.842.225-1.797.449-2.358.506 0-.113.056-.225.056-.394 0-.056 0-.112.056-.112a47.835 47.835 0 0 1 2.303-.393c1.179-.225 1.123-.056 1.123-.056Z",
    fill: "url(#signuphero_svg__G)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#signuphero_svg__H)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M227.024 254.503c-1.123.169-2.583.45-3.089.562 0 .056-.056.168-.056.225-.056.168-.056.28-.112.449.505-.056 1.909-.393 3.089-.674 1.348-.337 1.404-.562 1.404-.562s.112-.168-1.236 0Zm.562.169s-.056.112-1.18.449c-.842.225-1.797.449-2.358.506 0-.113.056-.225.056-.394 0-.056 0-.112.056-.112a47.835 47.835 0 0 1 2.303-.393c1.179-.225 1.123-.056 1.123-.056Z",
    fill: "url(#signuphero_svg__I)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "signuphero_svg__K",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 225,
    y: 255,
    width: 4,
    height: 7
  }, _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M228.653 255.57s-.112-.056-1.011 1.741c-.786 1.517-1.685 3.482-1.966 4.1.057 0 .113.056.113.056.112 0 .168.056.281.056.336-.674 1.179-2.583 1.853-4.099.842-1.854.73-1.854.73-1.854Zm-1.011 2.471c-.505 1.124-1.067 2.415-1.404 3.145-.056 0-.168-.056-.225-.056h-.112c.337-.73.955-2.022 1.46-3.145.73-1.46.786-1.46.786-1.46s.169 0-.505 1.516Z",
    fill: "url(#signuphero_svg__J)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#signuphero_svg__K)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M228.653 255.57s-.112-.056-1.011 1.741c-.786 1.517-1.685 3.482-1.966 4.1.057 0 .113.056.113.056.112 0 .168.056.281.056.336-.674 1.179-2.583 1.853-4.099.842-1.854.73-1.854.73-1.854Zm-1.011 2.471c-.505 1.124-1.067 2.415-1.404 3.145-.056 0-.168-.056-.225-.056h-.112c.337-.73.955-2.022 1.46-3.145.73-1.46.786-1.46.786-1.46s.169 0-.505 1.516Z",
    fill: "url(#signuphero_svg__L)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "signuphero_svg__N",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 229,
    y: 254,
    width: 4,
    height: 4
  }, _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M230.787 255.514c-.899-.786-1.011-.561-1.011-.561s-.112.168.674 1.067c.674.786 1.572 1.741 1.853 1.965l.169-.168c.112-.112.168-.281.28-.393-.336-.393-1.235-1.292-1.965-1.91Zm1.516 2.134-.112.113c-.337-.337-.955-.955-1.404-1.517-.674-.73-.562-.898-.562-.898s.113-.113.843.505c.505.45 1.179 1.067 1.46 1.404a3.32 3.32 0 0 0-.225.393Z",
    fill: "url(#signuphero_svg__M)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#signuphero_svg__N)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.787 255.514c-.899-.786-1.011-.561-1.011-.561s-.112.168.674 1.067c.674.786 1.572 1.741 1.853 1.965l.169-.168c.112-.112.168-.281.28-.393-.336-.393-1.235-1.292-1.965-1.91Zm1.516 2.134-.112.113c-.337-.337-.955-.955-1.404-1.517-.674-.73-.562-.898-.562-.898s.113-.113.843.505c.505.45 1.179 1.067 1.46 1.404a3.32 3.32 0 0 0-.225.393Z",
    fill: "url(#signuphero_svg__O)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "signuphero_svg__Q",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 230,
    y: 249,
    width: 5,
    height: 5
  }, _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M234.55 249.337c-.057-.113-.057-.225-.113-.281-.505.449-1.909 1.853-3.032 2.976-1.292 1.348-1.236 1.461-1.236 1.461s.056.112 1.404-1.067c1.179-1.067 2.64-2.415 3.089-2.865-.056-.112-.056-.168-.112-.224Zm-2.528 2.527c-1.123 1.011-1.179.898-1.179.898s-.056-.112 1.067-1.179c.786-.786 1.797-1.741 2.303-2.246.056.112.056.168.112.281 0 .056 0 .056.056.112-.562.449-1.572 1.404-2.359 2.134Z",
    fill: "url(#signuphero_svg__P)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#signuphero_svg__Q)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234.55 249.337c-.057-.113-.057-.225-.113-.281-.505.449-1.909 1.853-3.032 2.976-1.292 1.348-1.236 1.461-1.236 1.461s.056.112 1.404-1.067c1.179-1.067 2.64-2.415 3.089-2.865-.056-.112-.056-.168-.112-.224Zm-2.528 2.527c-1.123 1.011-1.179.898-1.179.898s-.056-.112 1.067-1.179c.786-.786 1.797-1.741 2.303-2.246.056.112.056.168.112.281 0 .056 0 .056.056.112-.562.449-1.572 1.404-2.359 2.134Z",
    fill: "url(#signuphero_svg__R)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "signuphero_svg__T",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 227,
    y: 255,
    width: 5,
    height: 7
  }, _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M229.383 255.964c.056-.113.112-.225.112-.394 0-.168-.112-.28-.281-.168a.67.67 0 0 0-.28.505c0 .113.056.225.112.225-.281.281-.786 1.348-1.629 5.391a6.436 6.436 0 0 0 1.797-.674c.618-.337 1.236-.842 1.798-1.347-.843-3.145-1.348-3.538-1.629-3.538Zm-.393-.113c0-.112.112-.281.224-.337.113-.056.225 0 .225.113 0 .112-.112.28-.225.337-.112.056-.224 0-.224-.113Zm-1.348 5.279c.562-3.875 1.46-4.436 1.572-4.549.113-.056 1.011-.505 1.573 2.808-.449.45-.955.787-1.46 1.067-.618.337-1.18.562-1.685.674Z",
    fill: "url(#signuphero_svg__S)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#signuphero_svg__T)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229.383 255.964c.056-.113.112-.225.112-.394 0-.168-.112-.28-.281-.168a.67.67 0 0 0-.28.505c0 .113.056.225.112.225-.281.281-.786 1.348-1.629 5.391a6.436 6.436 0 0 0 1.797-.674c.618-.337 1.236-.842 1.798-1.347-.843-3.145-1.348-3.538-1.629-3.538Zm-.393-.113c0-.112.112-.281.224-.337.113-.056.225 0 .225.113 0 .112-.112.28-.225.337-.112.056-.224 0-.224-.113Zm-1.348 5.279c.562-3.875 1.46-4.436 1.572-4.549.113-.056 1.011-.505 1.573 2.808-.449.45-.955.787-1.46 1.067-.618.337-1.18.562-1.685.674Z",
    fill: "url(#signuphero_svg__U)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "signuphero_svg__W",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 230,
    y: 251,
    width: 5,
    height: 5
  }, _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M234.83 251.022c-3.201 1.628-3.931 2.471-4.155 2.808 0-.113-.113-.169-.225-.113a.64.64 0 0 0-.393.449c-.056.225.056.337.168.337.113 0 .225-.112.281-.224.056.337.449.898 3.145 1.348.337-.73.618-1.573.842-2.359a8.376 8.376 0 0 0 .337-2.246Zm-4.268 3.032c-.056.112-.168.281-.224.281-.113 0-.169-.056-.113-.225.056-.112.169-.28.225-.28.112 0 .168.112.112.224Zm3.763-.842c-.169.73-.449 1.46-.786 2.19-2.752-.168-2.527-1.236-2.527-1.404.056-.168.393-1.292 3.538-2.64 0 .562-.057 1.18-.225 1.854Z",
    fill: "url(#signuphero_svg__V)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#signuphero_svg__W)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234.83 251.022c-3.201 1.628-3.931 2.471-4.155 2.808 0-.113-.113-.169-.225-.113a.64.64 0 0 0-.393.449c-.056.225.056.337.168.337.113 0 .225-.112.281-.224.056.337.449.898 3.145 1.348.337-.73.618-1.573.842-2.359a8.376 8.376 0 0 0 .337-2.246Zm-4.268 3.032c-.056.112-.168.281-.224.281-.113 0-.169-.056-.113-.225.056-.112.169-.28.225-.28.112 0 .168.112.112.224Zm3.763-.842c-.169.73-.449 1.46-.786 2.19-2.752-.168-2.527-1.236-2.527-1.404.056-.168.393-1.292 3.538-2.64 0 .562-.057 1.18-.225 1.854Z",
    fill: "url(#signuphero_svg__X)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "signuphero_svg__Z",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 229,
    y: 247,
    width: 5,
    height: 7
  }, _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M233.763 247.933a2.684 2.684 0 0 0-1.291-.73 3.954 3.954 0 0 0-1.629 0c-1.123 4.099-1.067 4.998-.955 5.223-.112.056-.168.168-.28.28-.113.225-.057.393.056.45.112.056.337-.113.449-.337.056-.113.056-.281.056-.337.337-.056 1.123-.787 3.594-4.549Zm-3.65 4.886c-.056.112-.168.224-.281.224-.112 0-.112-.168-.056-.281.056-.112.169-.224.281-.224.056 0 .112.168.056.281Zm.842-5.335c.45-.057.899-.057 1.292.056.449.112.842.337 1.179.674-2.246 3.762-3.032 3.706-3.088 3.65-.057 0-.73-.281.617-4.38Z",
    fill: "url(#signuphero_svg__Y)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#signuphero_svg__Z)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M233.763 247.933a2.684 2.684 0 0 0-1.291-.73 3.954 3.954 0 0 0-1.629 0c-1.123 4.099-1.067 4.998-.955 5.223-.112.056-.168.168-.28.28-.113.225-.057.393.056.45.112.056.337-.113.449-.337.056-.113.056-.281.056-.337.337-.056 1.123-.787 3.594-4.549Zm-3.65 4.886c-.056.112-.168.224-.281.224-.112 0-.112-.168-.056-.281.056-.112.169-.224.281-.224.056 0 .112.168.056.281Zm.842-5.335c.45-.057.899-.057 1.292.056.449.112.842.337 1.179.674-2.246 3.762-3.032 3.706-3.088 3.65-.057 0-.73-.281.617-4.38Z",
    fill: "url(#signuphero_svg__aa)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "signuphero_svg__ac",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 224,
    y: 249,
    width: 5,
    height: 6
  }, _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M228.765 253.268c-.056-.056-.168-.056-.281 0 .169-.393.225-1.404-.954-4.156-.562.506-1.124 1.179-1.629 1.91-.505.73-.955 1.46-1.292 2.246 2.471.898 3.258.674 3.595.449-.057.113 0 .225.056.281.112.112.281 0 .449-.168.112-.225.112-.45.056-.562Zm-.674-.056c-.112.112-.842 1.067-3.145-.113.281-.617.674-1.235 1.067-1.797a9.158 9.158 0 0 1 1.517-1.741c1.291 2.471.617 3.482.561 3.651Zm.506.505c-.113.113-.225.169-.281.113-.056-.057-.056-.225.056-.337.112-.113.225-.169.281-.113.056.056.056.225-.056.337Z",
    fill: "url(#signuphero_svg__ab)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#signuphero_svg__ac)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M228.765 253.268c-.056-.056-.168-.056-.281 0 .169-.393.225-1.404-.954-4.156-.562.506-1.124 1.179-1.629 1.91-.505.73-.955 1.46-1.292 2.246 2.471.898 3.258.674 3.595.449-.057.113 0 .225.056.281.112.112.281 0 .449-.168.112-.225.112-.45.056-.562Zm-.674-.056c-.112.112-.842 1.067-3.145-.113.281-.617.674-1.235 1.067-1.797a9.158 9.158 0 0 1 1.517-1.741c1.291 2.471.617 3.482.561 3.651Zm.506.505c-.113.113-.225.169-.281.113-.056-.057-.056-.225.056-.337.112-.113.225-.169.281-.113.056.056.056.225-.056.337Z",
    fill: "url(#signuphero_svg__ad)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "signuphero_svg__af",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 223,
    y: 255,
    width: 6,
    height: 6
  }, _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M228.316 255.177c-.056-.168-.225-.168-.393 0a1.173 1.173 0 0 0-.225.337c-.225-.112-.955-.056-4.156 1.966 0 .674.056 1.348.281 1.909.169.562.506 1.011.843 1.404 2.695-3.538 3.088-4.605 3.144-4.998.057 0 .169 0 .281-.112.225-.113.281-.337.225-.506Zm-3.482 5.279c-.281-.28-.505-.674-.674-1.179a5.666 5.666 0 0 1-.281-1.741c3.089-2.246 3.426-1.516 3.482-1.404.056.056.225.955-2.527 4.324Zm3.257-4.829c-.112.112-.224.112-.224 0-.057-.113 0-.281.112-.337.112-.113.225-.113.225 0 .056.056 0 .224-.113.337Z",
    fill: "url(#signuphero_svg__ae)"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#signuphero_svg__af)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M228.316 255.177c-.056-.168-.225-.168-.393 0a1.173 1.173 0 0 0-.225.337c-.225-.112-.955-.056-4.156 1.966 0 .674.056 1.348.281 1.909.169.562.506 1.011.843 1.404 2.695-3.538 3.088-4.605 3.144-4.998.057 0 .169 0 .281-.112.225-.113.281-.337.225-.506Zm-3.482 5.279c-.281-.28-.505-.674-.674-1.179a5.666 5.666 0 0 1-.281-1.741c3.089-2.246 3.426-1.516 3.482-1.404.056.056.225.955-2.527 4.324Zm3.257-4.829c-.112.112-.224.112-.224 0-.057-.113 0-.281.112-.337.112-.113.225-.113.225 0 .056.056 0 .224-.113.337Z",
    fill: "url(#signuphero_svg__ag)"
  }))), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M230.057 253.83c0 .561-.393 1.179-.843 1.46-.449.28-.842.056-.842-.506 0-.561.393-1.179.842-1.46.45-.225.843 0 .843.506Z",
    fill: "#CDE7EC"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M229.888 253.942c0 .449-.28.955-.674 1.123-.393.225-.674.056-.674-.393 0-.393.281-.955.674-1.123.337-.169.674 0 .674.393Z",
    fill: "url(#signuphero_svg__ah)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M229.214 255.402a.67.67 0 0 0-.28.505c0 .169.112.281.28.169a.668.668 0 0 0 .281-.506c0-.168-.112-.28-.281-.168Zm0 .562c-.112.056-.224 0-.224-.113 0-.112.112-.281.224-.337.113-.056.169 0 .169.113 0 .112-.056.28-.169.337ZM228.035 255.121a.672.672 0 0 0-.281.506c0 .168.113.28.281.168a.668.668 0 0 0 .281-.505c.056-.225-.112-.281-.281-.169Zm0 .562c-.112.056-.168 0-.168-.113 0-.112.112-.28.168-.337.112-.056.169 0 .169.113.056.112-.057.281-.169.337ZM230.394 253.773a.67.67 0 0 0-.281.506c0 .168.112.281.281.168a.671.671 0 0 0 .281-.505c0-.225-.113-.281-.281-.169Zm0 .562c-.113.056-.169 0-.169-.112 0-.113.113-.281.169-.337.112-.056.168 0 .168.112s-.056.281-.168.337ZM229.944 252.426a.668.668 0 0 0-.28.505c0 .168.112.281.28.168a.668.668 0 0 0 .281-.505c0-.168-.112-.225-.281-.168Zm0 .617c-.112.056-.168 0-.168-.112s.112-.281.168-.337c.113-.056.169 0 .169.112 0 .113-.056.225-.169.337ZM228.484 253.268a.67.67 0 0 0-.28.505c0 .169.112.281.28.169a.668.668 0 0 0 .281-.506c.056-.168-.112-.28-.281-.168Zm0 .562c-.112.056-.168 0-.168-.113 0-.112.112-.281.168-.337.113-.056.169 0 .169.113.056.112-.056.28-.169.337Z",
    fill: "#B1DAE1"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M228.709 253.493a.472.472 0 0 1-.225.393c-.112.056-.224 0-.224-.113 0-.168.112-.337.224-.393.169-.112.225-.056.225.113Z",
    fill: "#1A92A8"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M228.709 253.493c0 .112-.112.28-.225.336-.112.057-.224 0-.224-.112s.112-.281.224-.337c.113-.056.225 0 .225.113Z",
    fill: "url(#signuphero_svg__ai)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M230.169 252.65a.47.47 0 0 1-.225.393c-.112.056-.224 0-.224-.112 0-.169.112-.337.224-.393.113-.056.225 0 .225.112Z",
    fill: "#1A92A8"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M230.113 252.65c0 .112-.112.281-.225.337-.112.056-.224 0-.224-.112 0-.113.112-.281.224-.337.169-.056.225 0 .225.112Z",
    fill: "url(#signuphero_svg__aj)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M230.618 253.998a.473.473 0 0 1-.224.393c-.113.056-.225 0-.225-.112a.47.47 0 0 1 .225-.393c.112-.113.224-.056.224.112Z",
    fill: "#1A92A8"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M230.562 253.998c0 .112-.112.281-.224.337-.113.056-.225 0-.225-.112 0-.113.112-.281.225-.337.168-.057.224 0 .224.112Z",
    fill: "url(#signuphero_svg__ak)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M228.26 255.29a.474.474 0 0 1-.225.393c-.112.056-.225 0-.225-.113 0-.168.113-.337.225-.393.169-.056.225 0 .225.113Z",
    fill: "#1A92A8"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M228.26 255.346c0 .112-.113.281-.225.337-.112.056-.225 0-.225-.112 0-.113.113-.281.225-.337.112-.113.225-.057.225.112Z",
    fill: "url(#signuphero_svg__al)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M229.439 255.627a.472.472 0 0 1-.225.393c-.112.056-.224 0-.224-.113 0-.168.112-.337.224-.393.113-.112.225-.056.225.113Z",
    fill: "#1A92A8"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M229.439 255.627c0 .112-.112.28-.225.337-.112.056-.224 0-.224-.113 0-.112.112-.281.224-.337.113-.056.225 0 .225.113Z",
    fill: "url(#signuphero_svg__am)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.47 289.547c4.268-16.286 1.572-8.199-16.118-17.803l-3.875 6.571 19.993 11.232Z",
    fill: "#55B5C2"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M174.908 285.166c0-2.527-.954-4.268-2.471-4.942l-5.166-2.808c-1.124-.056-2.977.45-4.381 1.236-4.268 2.471-8.031 6.571-8.873 11.681-.056.281.112 3.033 0 3.538 0 0 .056 0 .056.056l8.368 4.774c1.348.674 3.089.505 5.054-.618 4.044-2.415 7.413-8.199 7.413-12.917Z",
    fill: "#284D68"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M174.908 285.166c0 4.718-3.313 10.502-7.413 12.861-4.099 2.359-7.413.449-7.413-4.268 0-4.718 3.314-10.502 7.413-12.861 4.044-2.415 7.413-.449 7.413 4.268Z",
    fill: "#284D68"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M174.684 285.447c0 4.437-3.089 9.772-6.908 12.018-3.819 2.191-6.908.393-6.908-3.987 0-4.437 3.089-9.772 6.908-12.018 3.819-2.19 6.908-.449 6.908 3.987Z",
    fill: "#0F7482"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M172.606 286.683c0-3.033-2.134-4.268-4.774-2.752-2.639 1.516-4.773 5.223-4.773 8.312 0 3.032 2.134 4.268 4.773 2.751 2.584-1.516 4.774-5.222 4.774-8.311Z",
    fill: "#2899AD"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M171.258 287.469c0-2.19-1.573-3.089-3.482-2.022-1.909 1.123-3.482 3.819-3.482 6.009 0 2.191 1.573 3.089 3.482 2.022 1.909-1.123 3.482-3.819 3.482-6.009Z",
    fill: "url(#signuphero_svg__an)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M167.776 282.695c-3.201 1.854-5.84 6.403-5.84 10.109 0 3.707 2.639 5.223 5.84 3.37 3.201-1.854 5.841-6.402 5.841-10.109s-2.584-5.223-5.841-3.37Zm0 12.243c-2.639 1.516-4.717.281-4.717-2.752 0-3.032 2.134-6.683 4.717-8.199 2.64-1.516 4.717-.281 4.717 2.752.057 3.033-2.077 6.683-4.717 8.199Z",
    fill: "#B1DAE1"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M167.776 283.313c-2.92 1.685-5.279 5.785-5.279 9.154 0 3.37 2.359 4.774 5.279 3.033 2.92-1.685 5.279-5.785 5.279-9.154.056-3.314-2.359-4.718-5.279-3.033Zm0 12.018c-2.808 1.629-5.054.281-5.054-2.92 0-3.257 2.246-7.188 5.054-8.817 2.808-1.629 5.054-.281 5.054 2.92.057 3.258-2.246 7.189-5.054 8.817Z",
    fill: "url(#signuphero_svg__ao)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M167.776 282.695c-3.201 1.854-5.84 6.403-5.84 10.109 0 3.707 2.639 5.223 5.84 3.37 3.201-1.854 5.841-6.402 5.841-10.109s-2.584-5.223-5.841-3.37Zm5.335 1.798c0 .056 0 .056.056.112a57.36 57.36 0 0 1-2.471 2.302c-1.179 1.067-1.235.955-1.235.955s-.056-.112 1.123-1.235c.842-.843 1.853-1.854 2.415-2.359a.424.424 0 0 1 .112.225Zm-3.482-2.191c.45-.056.955-.056 1.348.056.506.113.899.394 1.236.731-2.359 3.931-3.145 3.875-3.258 3.818-.056-.056-.786-.337.674-4.605Zm-.449 6.852c-.056.168-.168.281-.281.281-.112 0-.168-.057-.112-.225.056-.169.168-.281.281-.281.112 0 .168.112.112.225Zm-.786-1.348c.056-.169.168-.225.281-.225.112 0 .112.169.056.281-.056.169-.169.225-.281.225-.112 0-.168-.169-.056-.281Zm-.786-4.661c.112-.056.224-.113.28-.169.057 0 .057-.056.113-.056 0 .674 0 1.909-.056 2.977-.057 1.46-.169 1.516-.169 1.516s-.112.056-.168-1.292v-2.976Zm.393 7.637c0 .113-.113.281-.225.337-.112.057-.225 0-.225-.112s.113-.281.225-.337c.112-.056.225 0 .225.112Zm-1.067-2.19c.112-.112.224-.168.28-.112.057.056.057.224-.056.337-.112.112-.224.168-.28.112-.057-.056-.057-.225.056-.337Zm-2.471-2.359c.505-.673 1.011-1.291 1.572-1.797 1.404 2.584.73 3.651.618 3.819-.112.169-.899 1.123-3.257-.112.224-.618.617-1.292 1.067-1.91Zm2.19 4.549c-.112.113-.225.113-.281 0-.056-.112 0-.28.112-.393.113-.112.225-.112.281 0 .056.113 0 .281-.112.393Zm-4.1-.393c0-.056 0-.112.056-.168.562-.113 1.573-.281 2.415-.449 1.123-.169 1.123-.057 1.123-.057s-.056.169-1.235.45c-.842.224-1.909.449-2.471.561.056-.056.056-.168.112-.337Zm.674 5.448a3.71 3.71 0 0 1-.674-1.236 6.423 6.423 0 0 1-.281-1.853c3.202-2.359 3.595-1.572 3.595-1.46.056.112.224 1.011-2.64 4.549Zm1.46.73c-.056 0-.168-.056-.224-.056h-.113a138.11 138.11 0 0 1 1.573-3.258c.73-1.572.842-1.516.842-1.516s.113 0-.561 1.573c-.562 1.123-1.18 2.527-1.517 3.257Zm3.201-.73c-.617.337-1.179.561-1.741.674.618-4.044 1.517-4.662 1.629-4.718.112-.056 1.011-.505 1.629 2.921-.45.449-.955.786-1.517 1.123Zm3.089-2.977c-.056.056-.056.113-.112.113a50.813 50.813 0 0 1-1.46-1.573c-.674-.786-.562-.898-.562-.898s.112-.113.843.561a43.448 43.448 0 0 1 1.516 1.46 1.167 1.167 0 0 1-.225.337Zm1.348-2.358c-2.864-.169-2.639-1.292-2.639-1.461.056-.168.393-1.347 3.65-2.751 0 .617-.112 1.235-.281 1.909-.112.842-.393 1.573-.73 2.303Z",
    fill: "url(#signuphero_svg__ap)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M168.843 288.873c0 .674-.449 1.516-1.067 1.853-.561.337-1.067.056-1.067-.618 0-.673.449-1.516 1.067-1.853.618-.337 1.067-.056 1.067.618Z",
    fill: "url(#signuphero_svg__aq)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M168.057 282.583c-.056.056-.112.056-.169.112-.112.057-.224.169-.393.225 0 .618 0 2.415.056 3.875.057 1.629.225 1.573.225 1.573s.169-.113.225-1.798c.056-1.572.112-3.425.056-3.987Zm-.112 3.314c-.057 1.46-.169 1.516-.169 1.516s-.112.056-.168-1.292c-.057-1.011-.057-2.246-.057-2.92.113-.056.225-.112.281-.169.056 0 .056-.056.113-.056.056.618.056 1.853 0 2.921Z",
    fill: "url(#signuphero_svg__ar)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M165.53 289.659c-1.18.169-2.696.449-3.201.562 0 .056-.057.168-.057.224-.056.169-.056.337-.112.45.506-.056 2.022-.393 3.201-.73 1.404-.337 1.46-.562 1.46-.562s.057-.168-1.291.056Zm.561.169s-.056.168-1.235.449c-.843.225-1.91.449-2.471.562 0-.113.056-.281.112-.394 0-.056 0-.112.056-.168.562-.112 1.573-.281 2.415-.449 1.179-.169 1.123 0 1.123 0Z",
    fill: "url(#signuphero_svg__as)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M167.214 290.726s-.112-.056-1.01 1.797c-.787 1.629-1.741 3.595-2.022 4.268.056 0 .112.057.168.057.113 0 .225.056.337.056.337-.674 1.236-2.696 1.91-4.268.73-1.854.617-1.91.617-1.91Zm-1.067 2.584c-.505 1.123-1.123 2.527-1.46 3.257-.056 0-.168-.056-.224-.056h-.113a138.11 138.11 0 0 1 1.573-3.258c.73-1.572.842-1.516.842-1.516s.056 0-.618 1.573Z",
    fill: "url(#signuphero_svg__at)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M169.405 290.67c-.899-.786-1.011-.618-1.011-.618s-.112.169.674 1.123c.674.843 1.628 1.798 1.965 2.078a.756.756 0 0 0 .169-.224c.112-.169.168-.281.281-.45a47.33 47.33 0 0 0-2.078-1.909Zm1.572 2.19c-.056.056-.056.113-.112.113a50.813 50.813 0 0 1-1.46-1.573c-.674-.786-.562-.898-.562-.898s.112-.113.843.561a43.448 43.448 0 0 1 1.516 1.46 1.147 1.147 0 0 1-.225.337Z",
    fill: "url(#signuphero_svg__au)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M173.392 284.268c-.056-.112-.056-.225-.112-.337-.506.449-2.022 1.909-3.201 3.089-1.348 1.404-1.292 1.516-1.292 1.516s.056.168 1.46-1.123c1.236-1.123 2.752-2.527 3.257-3.033-.112 0-.112-.056-.112-.112Zm-2.696 2.639c-1.179 1.067-1.235.955-1.235.955s-.056-.112 1.123-1.235c.842-.843 1.853-1.854 2.415-2.359.056.112.056.168.112.281 0 .056 0 .056.056.112-.561.505-1.628 1.46-2.471 2.246Z",
    fill: "url(#signuphero_svg__av)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M167.945 291.119a.605.605 0 0 0 .168-.393c0-.224-.168-.281-.337-.168-.168.112-.337.337-.337.561 0 .113.056.225.169.225-.281.337-.843 1.404-1.685 5.616a5.523 5.523 0 0 0 1.853-.73 8.95 8.95 0 0 0 1.853-1.404c-.842-3.257-1.404-3.707-1.684-3.707Zm-.337-.056c0-.112.112-.281.224-.337.113-.056.225 0 .225.113 0 .112-.112.28-.225.337-.168.056-.224 0-.224-.113Zm-1.461 5.448c.618-4.044 1.517-4.662 1.629-4.718.112-.056 1.011-.505 1.629 2.921-.506.449-1.011.842-1.517 1.123-.617.337-1.179.561-1.741.674Z",
    fill: "url(#signuphero_svg__aw)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M173.617 286.009c-3.314 1.685-4.1 2.527-4.325 2.92 0-.112-.112-.168-.224-.112a.639.639 0 0 0-.393.449c-.057.225.056.393.224.337.113 0 .225-.112.281-.225.056.337.506.955 3.257 1.404a9.904 9.904 0 0 0 .843-2.471c.281-.786.337-1.572.337-2.302Zm-4.437 3.145c-.056.168-.168.281-.281.281-.112 0-.168-.057-.112-.225.056-.169.168-.281.281-.281.112 0 .168.112.112.225Zm3.931-.899c-.168.786-.449 1.517-.786 2.247-2.864-.169-2.639-1.292-2.639-1.461.056-.168.393-1.347 3.65-2.751.056.674-.056 1.291-.225 1.965Z",
    fill: "url(#signuphero_svg__ax)"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M172.55 282.808a2.348 2.348 0 0 0-1.348-.786 4.227 4.227 0 0 0-1.685 0c-1.179 4.268-1.123 5.222-.955 5.447a.671.671 0 0 0-.28.281c-.113.224-.057.449.056.449.168.056.337-.112.449-.337.056-.112.056-.281.056-.337.281-.112 1.123-.786 3.707-4.717Zm-3.819 5.054c-.056.169-.169.225-.281.225-.112 0-.112-.169-.056-.281.056-.169.168-.225.281-.225.056 0 .112.169.056.281Zm.898-5.56c.45-.056.955-.056 1.348.056.506.113.899.394 1.236.731-2.359 3.931-3.145 3.875-3.258 3.818-.056-.056-.786-.337.674-4.605Z",
    fill: "url(#signuphero_svg__ay)"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M167.327 288.368c-.056-.057-.169-.057-.281 0 .169-.394.225-1.461-.955-4.325-.617.562-1.179 1.236-1.684 1.966-.506.73-.955 1.516-1.348 2.302 2.583.955 3.425.674 3.706.45-.056.112 0 .28.056.337.113.112.281 0 .45-.169.112-.225.112-.505.056-.561Zm-.73-.113c-.113.169-.899 1.123-3.257-.112.336-.618.673-1.292 1.123-1.91.505-.673 1.011-1.291 1.572-1.797 1.348 2.584.674 3.651.562 3.819Zm.561.562c-.112.112-.224.168-.28.112-.057-.056-.057-.225.056-.337.112-.112.224-.168.281-.112.056.056.056.224-.057.337Z",
    fill: "url(#signuphero_svg__az)"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M166.878 290.333c-.057-.168-.225-.168-.394 0a.906.906 0 0 0-.224.393c-.225-.112-1.011-.056-4.324 2.078 0 .73.112 1.404.28 2.022.225.618.506 1.067.843 1.46 2.808-3.707 3.257-4.83 3.313-5.167.056.056.169 0 .281-.112.225-.281.281-.505.225-.674Zm-3.651 5.504a3.71 3.71 0 0 1-.674-1.236 6.423 6.423 0 0 1-.281-1.853c3.202-2.359 3.595-1.573 3.595-1.46.056.112.224 1.011-2.64 4.549Zm3.426-5.055c-.112.113-.225.113-.281 0-.056-.112 0-.28.112-.393.113-.112.225-.112.281 0 .056.113 0 .281-.112.393Z",
    fill: "url(#signuphero_svg__aA)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "signuphero_svg__aC",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 167,
    y: 282,
    width: 2,
    height: 7
  }, _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M168.057 282.583c-.056.056-.112.056-.169.112-.112.057-.224.169-.393.225 0 .618 0 2.415.056 3.875.057 1.629.225 1.573.225 1.573s.169-.113.225-1.798c.056-1.572.112-3.425.056-3.987Zm-.112 3.314c-.057 1.46-.169 1.516-.169 1.516s-.112.056-.168-1.292c-.057-1.011-.057-2.246-.057-2.92.113-.056.225-.112.281-.169.056 0 .056-.056.113-.056.056.618.056 1.853 0 2.921Z",
    fill: "url(#signuphero_svg__aB)"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#signuphero_svg__aC)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.057 282.583c-.056.056-.112.056-.169.112-.112.057-.224.169-.393.225 0 .618 0 2.415.056 3.875.057 1.629.225 1.573.225 1.573s.169-.113.225-1.798c.056-1.572.112-3.425.056-3.987Zm-.112 3.314c-.057 1.46-.169 1.516-.169 1.516s-.112.056-.168-1.292c-.057-1.011-.057-2.246-.057-2.92.113-.056.225-.112.281-.169.056 0 .056-.056.113-.056.056.618.056 1.853 0 2.921Z",
    fill: "url(#signuphero_svg__aD)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "signuphero_svg__aF",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 162,
    y: 289,
    width: 5,
    height: 2
  }, _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M165.53 289.659c-1.18.169-2.696.449-3.201.562 0 .056-.057.168-.057.224-.056.169-.056.337-.112.45.506-.056 2.022-.393 3.201-.73 1.404-.337 1.46-.562 1.46-.562s.057-.168-1.291.056Zm.561.169s-.056.168-1.235.449c-.843.225-1.91.449-2.471.562 0-.113.056-.281.112-.394 0-.056 0-.112.056-.168.562-.112 1.573-.281 2.415-.449 1.179-.169 1.123 0 1.123 0Z",
    fill: "url(#signuphero_svg__aE)"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#signuphero_svg__aF)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.53 289.659c-1.18.169-2.696.449-3.201.562 0 .056-.057.168-.057.224-.056.169-.056.337-.112.45.506-.056 2.022-.393 3.201-.73 1.404-.337 1.46-.562 1.46-.562s.057-.168-1.291.056Zm.561.169s-.056.168-1.235.449c-.843.225-1.91.449-2.471.562 0-.113.056-.281.112-.394 0-.056 0-.112.056-.168.562-.112 1.573-.281 2.415-.449 1.179-.169 1.123 0 1.123 0Z",
    fill: "url(#signuphero_svg__aG)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "signuphero_svg__aI",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 164,
    y: 290,
    width: 4,
    height: 7
  }, _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M167.214 290.726s-.112-.056-1.01 1.797c-.787 1.629-1.741 3.595-2.022 4.268.056 0 .112.057.168.057.113 0 .225.056.337.056.337-.674 1.236-2.696 1.91-4.268.73-1.854.617-1.91.617-1.91Zm-1.067 2.584c-.505 1.123-1.123 2.527-1.46 3.257-.056 0-.168-.056-.224-.056h-.113a138.11 138.11 0 0 1 1.573-3.258c.73-1.572.842-1.516.842-1.516s.056 0-.618 1.573Z",
    fill: "url(#signuphero_svg__aH)"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#signuphero_svg__aI)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.214 290.726s-.112-.056-1.01 1.797c-.787 1.629-1.741 3.595-2.022 4.268.056 0 .112.057.168.057.113 0 .225.056.337.056.337-.674 1.236-2.696 1.91-4.268.73-1.854.617-1.91.617-1.91Zm-1.067 2.584c-.505 1.123-1.123 2.527-1.46 3.257-.056 0-.168-.056-.224-.056h-.113a138.11 138.11 0 0 1 1.573-3.258c.73-1.572.842-1.516.842-1.516s.056 0-.618 1.573Z",
    fill: "url(#signuphero_svg__aJ)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "signuphero_svg__aL",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 168,
    y: 290,
    width: 4,
    height: 4
  }, _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M169.405 290.67c-.899-.786-1.011-.618-1.011-.618s-.112.169.674 1.123c.674.843 1.628 1.798 1.965 2.078a.756.756 0 0 0 .169-.224c.112-.169.168-.281.281-.45a47.33 47.33 0 0 0-2.078-1.909Zm1.572 2.19c-.056.056-.056.113-.112.113a50.813 50.813 0 0 1-1.46-1.573c-.674-.786-.562-.898-.562-.898s.112-.113.843.561a43.448 43.448 0 0 1 1.516 1.46 1.147 1.147 0 0 1-.225.337Z",
    fill: "url(#signuphero_svg__aK)"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#signuphero_svg__aL)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.405 290.67c-.899-.786-1.011-.618-1.011-.618s-.112.169.674 1.123c.674.843 1.628 1.798 1.965 2.078a.756.756 0 0 0 .169-.224c.112-.169.168-.281.281-.45a47.33 47.33 0 0 0-2.078-1.909Zm1.572 2.19c-.056.056-.056.113-.112.113a50.813 50.813 0 0 1-1.46-1.573c-.674-.786-.562-.898-.562-.898s.112-.113.843.561a43.448 43.448 0 0 1 1.516 1.46 1.147 1.147 0 0 1-.225.337Z",
    fill: "url(#signuphero_svg__aM)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "signuphero_svg__aO",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 168,
    y: 283,
    width: 6,
    height: 6
  }, _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M173.392 284.268c-.056-.112-.056-.225-.112-.337-.506.449-2.022 1.909-3.201 3.089-1.348 1.404-1.292 1.516-1.292 1.516s.056.168 1.46-1.123c1.236-1.123 2.752-2.527 3.257-3.033-.112 0-.112-.056-.112-.112Zm-2.696 2.639c-1.179 1.067-1.235.955-1.235.955s-.056-.112 1.123-1.235c.842-.843 1.853-1.854 2.415-2.359.056.112.056.168.112.281 0 .056 0 .056.056.112-.561.505-1.628 1.46-2.471 2.246Z",
    fill: "url(#signuphero_svg__aN)"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#signuphero_svg__aO)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.392 284.268c-.056-.112-.056-.225-.112-.337-.506.449-2.022 1.909-3.201 3.089-1.348 1.404-1.292 1.516-1.292 1.516s.056.168 1.46-1.123c1.236-1.123 2.752-2.527 3.257-3.033-.112 0-.112-.056-.112-.112Zm-2.696 2.639c-1.179 1.067-1.235.955-1.235.955s-.056-.112 1.123-1.235c.842-.843 1.853-1.854 2.415-2.359.056.112.056.168.112.281 0 .056 0 .056.056.112-.561.505-1.628 1.46-2.471 2.246Z",
    fill: "url(#signuphero_svg__aP)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "signuphero_svg__aR",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 165,
    y: 290,
    width: 5,
    height: 7
  }, _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M167.945 291.119a.605.605 0 0 0 .168-.393c0-.224-.168-.281-.337-.168-.168.112-.337.337-.337.561 0 .113.056.225.169.225-.281.337-.843 1.404-1.685 5.616a5.523 5.523 0 0 0 1.853-.73 8.95 8.95 0 0 0 1.853-1.404c-.842-3.257-1.404-3.707-1.684-3.707Zm-.337-.056c0-.112.112-.281.224-.337.113-.056.225 0 .225.113 0 .112-.112.28-.225.337-.168.056-.224 0-.224-.113Zm-1.461 5.448c.618-4.044 1.517-4.662 1.629-4.718.112-.056 1.011-.505 1.629 2.921-.506.449-1.011.842-1.517 1.123-.617.337-1.179.561-1.741.674Z",
    fill: "url(#signuphero_svg__aQ)"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#signuphero_svg__aR)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.945 291.119a.605.605 0 0 0 .168-.393c0-.224-.168-.281-.337-.168-.168.112-.337.337-.337.561 0 .113.056.225.169.225-.281.337-.843 1.404-1.685 5.616a5.523 5.523 0 0 0 1.853-.73 8.95 8.95 0 0 0 1.853-1.404c-.842-3.257-1.404-3.707-1.684-3.707Zm-.337-.056c0-.112.112-.281.224-.337.113-.056.225 0 .225.113 0 .112-.112.28-.225.337-.168.056-.224 0-.224-.113Zm-1.461 5.448c.618-4.044 1.517-4.662 1.629-4.718.112-.056 1.011-.505 1.629 2.921-.506.449-1.011.842-1.517 1.123-.617.337-1.179.561-1.741.674Z",
    fill: "url(#signuphero_svg__aS)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "signuphero_svg__aU",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 168,
    y: 286,
    width: 6,
    height: 5
  }, _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M173.617 286.009c-3.314 1.685-4.1 2.527-4.325 2.92 0-.112-.112-.168-.224-.112a.639.639 0 0 0-.393.449c-.057.225.056.393.224.337.113 0 .225-.112.281-.225.056.337.506.955 3.257 1.404a9.904 9.904 0 0 0 .843-2.471c.281-.786.337-1.572.337-2.302Zm-4.437 3.145c-.056.168-.168.281-.281.281-.112 0-.168-.057-.112-.225.056-.169.168-.281.281-.281.112 0 .168.112.112.225Zm3.931-.899c-.168.786-.449 1.517-.786 2.247-2.864-.169-2.639-1.292-2.639-1.461.056-.168.393-1.347 3.65-2.751.056.674-.056 1.291-.225 1.965Z",
    fill: "url(#signuphero_svg__aT)"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#signuphero_svg__aU)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.617 286.009c-3.314 1.685-4.1 2.527-4.325 2.92 0-.112-.112-.168-.224-.112a.639.639 0 0 0-.393.449c-.057.225.056.393.224.337.113 0 .225-.112.281-.225.056.337.506.955 3.257 1.404a9.904 9.904 0 0 0 .843-2.471c.281-.786.337-1.572.337-2.302Zm-4.437 3.145c-.056.168-.168.281-.281.281-.112 0-.168-.057-.112-.225.056-.169.168-.281.281-.281.112 0 .168.112.112.225Zm3.931-.899c-.168.786-.449 1.517-.786 2.247-2.864-.169-2.639-1.292-2.639-1.461.056-.168.393-1.347 3.65-2.751.056.674-.056 1.291-.225 1.965Z",
    fill: "url(#signuphero_svg__aV)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "signuphero_svg__aX",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 168,
    y: 281,
    width: 5,
    height: 8
  }, _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M172.55 282.808a2.348 2.348 0 0 0-1.348-.786 4.227 4.227 0 0 0-1.685 0c-1.179 4.268-1.123 5.222-.955 5.447a.671.671 0 0 0-.28.281c-.113.224-.057.449.056.449.168.056.337-.112.449-.337.056-.112.056-.281.056-.337.281-.112 1.123-.786 3.707-4.717Zm-3.819 5.054c-.056.169-.169.225-.281.225-.112 0-.112-.169-.056-.281.056-.169.168-.225.281-.225.056 0 .112.169.056.281Zm.898-5.56c.45-.056.955-.056 1.348.056.506.113.899.394 1.236.731-2.359 3.931-3.145 3.875-3.258 3.818-.056-.056-.786-.337.674-4.605Z",
    fill: "url(#signuphero_svg__aW)"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#signuphero_svg__aX)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.55 282.808a2.348 2.348 0 0 0-1.348-.786 4.227 4.227 0 0 0-1.685 0c-1.179 4.268-1.123 5.222-.955 5.447a.671.671 0 0 0-.28.281c-.113.224-.057.449.056.449.168.056.337-.112.449-.337.056-.112.056-.281.056-.337.281-.112 1.123-.786 3.707-4.717Zm-3.819 5.054c-.056.169-.169.225-.281.225-.112 0-.112-.169-.056-.281.056-.169.168-.225.281-.225.056 0 .112.169.056.281Zm.898-5.56c.45-.056.955-.056 1.348.056.506.113.899.394 1.236.731-2.359 3.931-3.145 3.875-3.258 3.818-.056-.056-.786-.337.674-4.605Z",
    fill: "url(#signuphero_svg__aY)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "signuphero_svg__ba",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 163,
    y: 284,
    width: 5,
    height: 6
  }, _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M167.327 288.368c-.056-.057-.169-.057-.281 0 .169-.394.225-1.461-.955-4.325-.617.562-1.179 1.236-1.684 1.966-.506.73-.955 1.516-1.348 2.302 2.583.955 3.425.674 3.706.45-.056.112 0 .28.056.337.113.112.281 0 .45-.169.112-.225.112-.505.056-.561Zm-.73-.113c-.113.169-.899 1.123-3.257-.112.336-.618.673-1.292 1.123-1.91.505-.673 1.011-1.291 1.572-1.797 1.348 2.584.674 3.651.562 3.819Zm.561.562c-.112.112-.224.168-.28.112-.057-.056-.057-.225.056-.337.112-.112.224-.168.281-.112.056.056.056.224-.057.337Z",
    fill: "url(#signuphero_svg__aZ)"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#signuphero_svg__ba)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.327 288.368c-.056-.057-.169-.057-.281 0 .169-.394.225-1.461-.955-4.325-.617.562-1.179 1.236-1.684 1.966-.506.73-.955 1.516-1.348 2.302 2.583.955 3.425.674 3.706.45-.056.112 0 .28.056.337.113.112.281 0 .45-.169.112-.225.112-.505.056-.561Zm-.73-.113c-.113.169-.899 1.123-3.257-.112.336-.618.673-1.292 1.123-1.91.505-.673 1.011-1.291 1.572-1.797 1.348 2.584.674 3.651.562 3.819Zm.561.562c-.112.112-.224.168-.28.112-.057-.056-.057-.225.056-.337.112-.112.224-.168.281-.112.056.056.056.224-.057.337Z",
    fill: "url(#signuphero_svg__bb)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "signuphero_svg__bd",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 161,
    y: 290,
    width: 6,
    height: 7
  }, _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M166.878 290.333c-.057-.168-.225-.168-.394 0a.906.906 0 0 0-.224.393c-.225-.112-1.011-.056-4.324 2.078 0 .73.112 1.404.28 2.022.225.618.506 1.067.843 1.46 2.808-3.707 3.257-4.83 3.313-5.167.056.056.169 0 .281-.112.225-.281.281-.505.225-.674Zm-3.651 5.504a3.71 3.71 0 0 1-.674-1.236 6.423 6.423 0 0 1-.281-1.853c3.202-2.359 3.595-1.573 3.595-1.46.056.112.224 1.011-2.64 4.549Zm3.426-5.055c-.112.113-.225.113-.281 0-.056-.112 0-.28.112-.393.113-.112.225-.112.281 0 .056.113 0 .281-.112.393Z",
    fill: "url(#signuphero_svg__bc)"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#signuphero_svg__bd)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.878 290.333c-.057-.168-.225-.168-.394 0a.906.906 0 0 0-.224.393c-.225-.112-1.011-.056-4.324 2.078 0 .73.112 1.404.28 2.022.225.618.506 1.067.843 1.46 2.808-3.707 3.257-4.83 3.313-5.167.056.056.169 0 .281-.112.225-.281.281-.505.225-.674Zm-3.651 5.504a3.71 3.71 0 0 1-.674-1.236 6.423 6.423 0 0 1-.281-1.853c3.202-2.359 3.595-1.573 3.595-1.46.056.112.224 1.011-2.64 4.549Zm3.426-5.055c-.112.113-.225.113-.281 0-.056-.112 0-.28.112-.393.113-.112.225-.112.281 0 .056.113 0 .281-.112.393Z",
    fill: "url(#signuphero_svg__be)"
  }))), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M168.675 288.929c0 .562-.393 1.236-.899 1.516-.505.281-.898.057-.898-.505s.393-1.236.898-1.516c.506-.281.899-.056.899.505Z",
    fill: "#CDE7EC"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M168.506 289.041c0 .45-.337.955-.674 1.18-.393.224-.674.056-.674-.393 0-.45.281-.955.674-1.18.337-.224.674 0 .674.393Z",
    fill: "url(#signuphero_svg__bf)"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M167.776 290.558c-.168.112-.337.337-.337.561 0 .225.169.281.337.169.169-.112.337-.337.337-.562 0-.168-.168-.281-.337-.168Zm0 .618c-.112.056-.225 0-.225-.113 0-.112.113-.281.225-.337.112-.056.225 0 .225.113 0 .112-.113.28-.225.337ZM166.597 290.221c-.169.112-.337.337-.337.561 0 .225.168.281.337.169.168-.112.337-.337.337-.562-.056-.168-.169-.224-.337-.168Zm0 .618c-.113.056-.225 0-.225-.113 0-.112.112-.281.225-.337.112-.056.224 0 .224.113-.056.112-.112.28-.224.337ZM169.012 288.873c-.169.112-.337.337-.337.562 0 .224.168.28.337.168.168-.112.337-.337.337-.562-.057-.224-.169-.28-.337-.168Zm0 .562c-.113.056-.225 0-.225-.113 0-.112.112-.281.225-.337.112-.056.224 0 .224.113-.056.112-.112.28-.224.337ZM168.562 287.469c-.168.112-.337.337-.337.562 0 .224.169.28.337.168.169-.112.337-.337.337-.562-.056-.168-.168-.28-.337-.168Zm0 .618c-.112.056-.224 0-.224-.113 0-.112.112-.28.224-.337.113-.056.225 0 .225.113-.056.112-.112.281-.225.337ZM167.046 288.368c-.168.112-.337.336-.337.561 0 .225.169.281.337.169.169-.113.337-.337.337-.562 0-.225-.168-.281-.337-.168Zm0 .561c-.112.056-.225 0-.225-.112 0-.113.113-.281.225-.337.112-.056.225 0 .225.112s-.113.281-.225.337Z",
    fill: "#B1DAE1"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M167.271 288.592a.473.473 0 0 1-.225.393c-.112.056-.225 0-.225-.112 0-.169.113-.337.225-.393.112-.112.225-.056.225.112Z",
    fill: "#1A92A8"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M167.271 288.592c0 .112-.113.281-.225.393-.112.056-.225 0-.225-.112s.113-.281.225-.393c.112-.112.225-.056.225.112Z",
    fill: "url(#signuphero_svg__bg)"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M168.787 287.694a.472.472 0 0 1-.225.393c-.112.056-.224 0-.224-.113 0-.168.112-.337.224-.393.113-.112.225 0 .225.113Z",
    fill: "#1A92A8"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M168.731 287.694c0 .112-.113.281-.225.393-.112.056-.224 0-.224-.112 0-.113.112-.281.224-.394.169-.056.225 0 .225.113Z",
    fill: "url(#signuphero_svg__bh)"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M169.236 289.098a.473.473 0 0 1-.224.393c-.113.056-.225 0-.225-.113 0-.168.112-.337.225-.393.112-.112.224-.056.224.113Z",
    fill: "#1A92A8"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M169.236 289.098c0 .112-.112.28-.224.393-.113.056-.225 0-.225-.113 0-.112.112-.28.225-.393.112-.056.224 0 .224.113Z",
    fill: "url(#signuphero_svg__bi)"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M166.821 290.502a.473.473 0 0 1-.224.393c-.113.056-.225 0-.225-.113 0-.168.112-.337.225-.393.112-.112.224-.056.224.113Z",
    fill: "#1A92A8"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M166.821 290.502c0 .112-.112.28-.224.393-.113.056-.225 0-.225-.113 0-.112.112-.28.225-.393.112-.112.224-.056.224.113Z",
    fill: "url(#signuphero_svg__bj)"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M168.057 290.782a.474.474 0 0 1-.225.394c-.112.056-.224 0-.224-.113 0-.168.112-.337.224-.393.113-.112.225-.056.225.112Z",
    fill: "#1A92A8"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M168.001 290.782c0 .113-.113.281-.225.393-.112.057-.225 0-.225-.112s.113-.281.225-.393c.112-.056.225 0 .225.112Z",
    fill: "url(#signuphero_svg__bk)"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.682 270.284c.842-12.186 7.525-14.77 17.129-20.779 7.3-8.031 14.657-14.208 22.519-19.319 6.683-4.324 16.006-9.21 24.317-12.074 7.807-2.696 19.432-4.886 27.35-3.65 7.75-.786 12.243 2.415 19.487 7.637 10.614 7.694 20.948 22.913 7.638 33.303.955-2.19 1.46-4.437 1.46-6.515 0-5.728-4.156-8.03-9.041-5.166-4.999 2.864-8.986 9.884-8.986 15.612 0 1.348.225 2.527.674 3.482.056.393.056.786.168 1.179-14.208 7.638-30.663 17.915-44.927 25.497.056-.281.112-.506.168-.787.45-1.516.73-3.088.73-4.492 0-5.729-4.155-8.031-9.041-5.167-4.998 2.864-8.986 9.884-8.986 15.612 0 .899.113 1.685.281 2.359 0 .112.056.281.056.393-3.313 2.303-9.21 2.247-12.355 1.292-5.11-1.573-15.612-8.705-20.161-11.401-8.312-4.885-9.154-6.795-8.48-17.016Z",
    fill: "#B5E2E8"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.434 260.456c-.506 5.223-.393 10.614.954 12.524 1.966 2.696 9.211 7.694 12.692 8.424 1.629.337 3.482.168 6.01-.843 8.929-3.594 19.655-7.974 26.394-12.748 2.078-1.46 4.381-3.538 5.953-5.56 8.537-10.951 12.468-17.409 26.227-24.934 8.031-4.381 18.532-8.087 26.395-7.694 3.201.168 5.279.898 6.233.393 1.404-.786 1.348-3.313-2.808-7.975l.113.056c10.614 7.694 20.947 22.913 7.637 33.303.955-2.19 1.461-4.437 1.461-6.515 0-5.728-3.875-7.469-8.761-4.605-3.089 1.798-7.133 7.189-8.087 10.558-1.011 3.538-.787 6.74-.393 9.154-14.209 7.638-30.663 17.915-44.928 25.497.056-.281.112-.506.169-.787.449-1.516.73-3.088.73-4.492 0-5.729-4.156-8.031-9.042-5.167-4.998 2.864-8.986 9.884-8.986 15.612 0 .899.113 1.685.281 2.359 0 .112.056.281.056.393-3.313 2.303-9.21 2.247-12.355 1.292-5.503-1.685-25.496-12.524-28.978-17.353-2.078-2.865.955-17.522 3.033-20.892Z",
    fill: "#B5E2E8"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m223.037 242.822-56.833 31.618c-6.459 3.594-9.941 7.188-13.479 12.636-.954-3.763 5.111-12.131 9.997-14.658 23.137-12.074 36.503-19.992 59.473-32.572 3.65-2.022 9.771-7.919 12.692-8.368-4.1 4.549-6.796 8.536-11.85 11.344Z",
    fill: "#A1D2DB"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.816 275.17c5.335 4.493 13.254 9.266 20.498 12.692l-.842 1.741c-.674 1.236-1.18 2.583-3.033 1.685-6.121-2.977-12.074-6.346-17.016-10.67-.786-.731-.843-2.808.393-5.448Z",
    fill: "#73BCCA"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M233.651 226.761c.618 3.482.225 4.717-1.685 7.469-.168.281.393 1.853 1.236 2.134 2.527.73 4.268.842 7.581 0-.168-5.784-3.032-8.031-7.132-9.603Z",
    fill: "#EBF2F3"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.285 276.125c-2.471 4.043-4.436 6.065-6.121 7.132-2.977 1.853-14.602 1.853-13.984-.337 1.573-5.728 3.426-4.605 10.67-5.447 3.145-.337 5.841-.562 9.435-1.348ZM126.274 255.29c-.168 4.661-3.145 5.391-3.369 10.501-.225 2.64-.674 3.258-2.64 4.999-2.695-7.076.393-11.906 6.009-15.5Z",
    fill: "#E4F2F4"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.367 216.371c5.054 2.078 10.895 5.504 15.837 11.12 1.01 1.179.73 1.853-.45 1.685l-4.043-.337c-1.797-.169-1.517-.057-2.977-1.067-6.009-3.988-12.523-7.807-18.813-11.176-2.752-1.516-2.471-1.516-.281-1.404l5.223.056c2.527.112 3.089.112 5.504 1.123Z",
    fill: "#284D68"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.367 216.371c5.054 2.078 10.895 5.504 15.837 11.12 1.01 1.179.73 1.853-.45 1.685h-.112c.281-.281.112-.787-.505-1.517-4.942-5.616-10.727-8.985-15.837-11.119-2.415-1.011-2.977-1.067-5.504-1.124l-5.223-.056h-.674c-.056-.224.562-.168 1.741-.168l5.223.056c2.527.112 3.089.112 5.504 1.123ZM161.486 232.489c6.571 4.38 12.861 7.975 19.319 11.906 2.583 1.572 3.089 1.797 1.179 4.38-4.324 5.841-8.367 11.625-13.702 16.174-1.629 1.348-3.539 1.797-5.504 1.011-7.189-3.033-16.848-8.143-23.924-14.826-1.067-1.011-1.516-2.303-.168-3.987 4.268-5.279 11.4-10.952 17.577-14.883 1.798-1.179 3.426-.954 5.223.225Z",
    fill: "#284D68"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.628 258.435c-1.966 2.358-4.044 4.605-6.346 6.57-1.629 1.348-3.539 1.797-5.504 1.011-7.189-3.033-16.848-8.143-23.924-14.826-1.067-1.011-1.516-2.303-.168-3.987.28-.337.561-.73.898-1.067l-.112.168c-1.348 1.685-.899 2.977.168 3.987 7.132 6.74 16.736 11.85 23.924 14.827 1.966.842 3.875.393 5.504-1.011 2.021-1.741 3.819-3.651 5.56-5.672Z",
    fill: "#1A92A8"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M219.387 228.614a.518.518 0 0 0-.225-1.011c-7.188 1.516-12.748 3.201-18.14 5.784-5.391 2.584-10.501 6.01-16.735 11.064a.48.48 0 0 0-.056.73.48.48 0 0 0 .73.056c6.177-4.998 11.232-8.368 16.567-10.951 5.223-2.527 10.726-4.212 17.859-5.672ZM197.765 216.203c.281-.056.449-.337.449-.618-.056-.281-.336-.449-.617-.449-5.167.842-10.895 2.19-16.904 4.492a71.014 71.014 0 0 0-18.533 10.502.533.533 0 0 0-.112.73.533.533 0 0 0 .73.113c6.121-4.83 12.299-8.087 18.252-10.39 5.953-2.246 11.625-3.538 16.735-4.38Z",
    fill: "#2FA2AC"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.742 252.032c1.347 1.629 1.404 2.191 1.628 4.156v.169l.169 14.826.505-.281-.112-14.545v-.169c-.225-2.134-.281-2.695-1.741-4.436l-.449.28Z",
    fill: "#A1D2DB"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.988 271.014c-.056-3.201.168-8.704 0-11.849-.168-3.988 0-5.672-2.19-7.807-.393-5.278-1.011-7.581-2.471-12.242-.281-.899 15.724-6.739 16.286-6.29 2.19 1.909 3.37 3.313 5.335 5.728l1.573.674c1.572.674 2.134 1.685 2.358 2.977.225 1.46.056 2.864-.112 4.268-2.583 2.414-4.212 5.11-5.391 8.48-.843 2.358-1.124 4.717-1.629 8.311l-13.534 7.806-.225-.056Z",
    fill: "#37A8B7"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m203.325 236.532-.674 3.651V241.194c0 .056 0 .056.056.112 0 0 0 .056.056.056 0 .056.057.056.057.112 0 0 0 .057.056.057 0 .056.056.056.056.112 0 0 0 .056.056.056.056.056.112.056.112.112l16.118 8.986c.056-.506.056-.955.112-1.236l1.854-10.445-1.236-.506c-.224-.28-.449-.505-.618-.786l-7.581-4.268c-2.359.674-5.672 1.853-8.424 2.976Z",
    fill: "#1A92A8"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m211.749 233.444 7.638 4.268c-1.629-1.966-2.808-3.257-4.718-4.942-.168-.113-1.292.168-2.92.674Z",
    fill: "#6BBFCA"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m221.24 239.003-1.853 10.446c-.169.899.112 1.516.673 1.629.787-1.404 1.741-2.752 2.921-3.931l.898-5.111c-.224-1.235-.786-2.246-2.302-2.92l-.337-.113Z",
    fill: "#138999"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m218.039 255.683-9.042 5.166c-1.235.73-1.685-.393-1.572-1.741.168-2.751 2.021-4.211 4.436-5.503 2.19-1.236 4.774-2.415 6.683-3.201.674 0 1.179.224 1.516.618-.673 1.179-1.235 2.471-1.74 3.818-.113.281-.169.562-.281.843Z",
    fill: "#4FB2C0"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m219.948 250.741-16.23-9.435c-.056 0-.056-.056-.112-.056H202.651c-.056 0-.112.056-.168.056h-.169c-.056.056-.112.056-.225.112l16.567 9.66s.057 0 .057-.056c.056 0 .056 0 .112-.057.056 0 .056 0 .112-.056.056 0 .056 0 .113-.056h.224l.169-.056h.224l.281-.056Z",
    fill: "#6BBFCA"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m207.874 259.895-4.942-2.864c0 .337.056.73.056 1.179l5.111 2.976c-.169-.28-.281-.674-.225-1.291ZM211.019 255.514l-6.908-4.661-3.482-1.46c.056.618.113 1.235.169 1.909 1.797 1.741 2.022 3.145 2.134 5.729l4.942 2.864c0-1.404 1.011-3.145 2.246-3.875l.899-.506Z",
    fill: "#5FB9C5"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m210.12 256.076-9.322-5.448c-.281-3.201-.618-5.279-1.236-7.637l2.64-1.517 16.567 9.66-8.649 4.942Z",
    fill: "#6BBFCA"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m202.595 254.335 21.29-11.885s-.118-1.986-1.803-3.11l-20.891 12.355c-.056 0 1.292 1.685 1.404 2.64Z",
    fill: "#A1D2DB"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M226.687 232.714c-.842 2.134-2.752 4.492-4.717 5.672l-43.299 25.665c-.786.561-1.909.73-2.246.336-.843-.954 2.695-7.188 3.762-8.592 2.247-3.089 4.325-5.56 6.627-7.862 5.841-5.897 12.58-9.772 24.317-13.535 3.707-1.179 7.413-1.965 13.141-2.92 2.134-.337 3.145-.562 2.415 1.236Z",
    fill: "#1A92A8"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.81 232.04c-.73 2.302-2.414 5.335-4.436 6.514l-52.172 30.944c-1.91 1.123-1.573.168-.449-1.404l3.594-5.223c4.605-6.402 8.255-11.288 12.242-15.331 6.01-6.066 12.805-10.053 25.048-13.928 3.818-1.235 7.862-1.853 13.815-2.808 2.078-.337 2.808-.168 2.358 1.236Zm-28.304 7.244c1.853 3.37 2.64 7.02 2.752 10.783l15.444-9.154c0-3.538-1.123-5.672-3.819-6.852-1.011.281-1.966.562-2.92.843-4.549 1.348-8.256 2.808-11.457 4.38Zm-1.404 13.142c.281-4.212.225-7.694-1.348-11.738-3.65 2.078-6.683 4.437-9.434 7.245-2.191 2.246-4.212 4.661-6.403 7.637-1.011 1.404-4.492 7.413-3.65 8.368.337.337 1.404.169 2.134-.337l18.701-11.175Zm18.196-19.039c2.022 2.135 3.762 3.595 5.84 4.774 1.629-1.235 3.089-3.145 3.819-4.998.674-1.741-.281-1.516-2.302-1.179-2.921.505-5.279.954-7.357 1.403Z",
    fill: "#284D68"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "m141.213 246.81 17.802-14.49c1.629 1.18 5.953 4.212 7.301 5.111.73.337-25.103 9.379-25.103 9.379Z",
    fill: "#5FB3C2"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M142.392 278.147s7.919-.562 14.433-1.741c1.797-.337-1.179 2.302-3.65 2.471-2.415.224-8.874.617-10.783-.73Z",
    fill: "#F4F9F9"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.274 255.29s-1.572 1.067-2.246 1.628c-.674.562-1.123 3.37-1.067 4.493.056 1.123.112 2.864.112 2.864s.618-2.246 1.91-4.493c1.179-2.246 1.291-4.492 1.291-4.492Z",
    fill: "#F4F9F9"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "m152.22 294.264-3.089.225-.168-.562-.899-2.583c-1.965-.056-7.413 0-7.413 0 1.573 2.078 3.987 3.257 6.683 3.594 2.696.337 5.279.169 5.279.169s-.112-.393-.393-.843Z",
    fill: "#A1D2DB"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "m152.22 294.264-3.089.225-.168-.562-.899-2.583c-1.965-.056-7.413 0-7.413 0 1.573 2.078 3.987 3.257 6.683 3.594 2.696.337 5.279.169 5.279.169s-.112-.393-.393-.843Z",
    fill: "url(#signuphero_svg__bl)"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M151.602 293.029c-.561-.899-1.572-1.573-3.257-1.629h-.281l.899 2.583.168.562 3.089-.225a9.155 9.155 0 0 0-.618-1.291Z",
    fill: "url(#signuphero_svg__bm)"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M149.693 293.646c0 .731-.506 1.068-1.18.674-.617-.393-1.179-1.291-1.179-2.021s.506-1.067 1.179-.674c.674.393 1.18 1.291 1.18 2.021Z",
    fill: "#fff"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M118.637 276.181c-.506.505-1.124.393-1.292-.337-.169-.73.056-1.741.618-2.246.505-.506 1.123-.394 1.291.337.169.73-.056 1.74-.617 2.246Z",
    fill: "url(#signuphero_svg__bn)"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.651 254.335s.505 8.199.393 16.623l13.703-7.75s.618-11.176 7.301-16.904c0 0 .281-1.572.112-4.043l-21.509 12.074Z",
    fill: "#B5E2E8"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.367 261.13c1.179.056 2.864.449 3.313.955.73.842.225 2.527-.337 3.538-.842 1.572-6.177.955-7.413.393.281-3.089 1.573-4.998 4.437-4.886Z",
    fill: "#D1E9EE"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.026 239.34c1.741 1.292 1.853 2.808 1.797 4.605v.506c0 .842 0 1.516-.112 1.685-2.022 1.853-3.651 4.268-4.886 7.132-1.236 2.92-2.022 6.234-2.303 9.715l-38.356 22.577c0-4.212-.057-9.772-.618-14.377-.113-1.011-.281-1.685-.562-2.303-.281-.618-.898-1.291-1.516-1.965l-.449.28c.561.618 1.179 1.348 1.46 1.91.281.561.393 1.179.505 2.134.562 4.661.618 10.389.618 14.601v.618l.393-.225 38.862-22.856.113-.057v-.112c.28-3.538 1.067-6.795 2.302-9.715 1.18-2.808 2.808-5.167 4.774-6.964.224-.281.224-1.067.281-2.022v-.505c.056-1.966-.169-3.538-1.854-4.886l-.449.224Z",
    fill: "#A1D2DB"
  }))), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "m19.03 100.519.466-.117c-1.28-4.087-3.083-8-5.526-11.619-.64-.934-1.105-1.576-1.396-1.985-.058-.059-.058-.117-.116-.175-3.723-4.963-11.401-15.298-9.482-25.34.116-.7.465-2.51 1.338-4.38 1.047-2.335 2.501-3.736 4.246-4.261 2.734-1.11 6.515 1.4 7.853 2.277l.233-.41c-.873-.583-3.258-1.926-4.188-2.218-1.455-.467-2.792-.467-4.072-.116-1.92.583-3.432 2.101-4.537 4.554-.873 1.926-1.222 3.853-1.338 4.437-.466 2.394-.407 4.963.174 7.649.466 2.277 1.338 4.729 2.56 7.181 2.152 4.496 5.002 8.291 6.864 10.802.058.058.058.117.116.175.29.409.814 1.05 1.396 1.985a47.582 47.582 0 0 1 5.41 11.561Z",
    fill: "#0E4047"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M11.527 133.799v-1.693h.64c.872-1.869 2.56-3.62 5.06-5.08 7.679-4.437 20.069-4.437 27.747 0 2.501 1.46 4.188 3.211 5.06 5.08h.699v2.102c0 2.919-1.92 5.78-5.759 7.999-7.678 4.437-20.068 4.437-27.746 0-4.014-2.336-5.934-5.372-5.701-8.408Z",
    fill: "#087684"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M17.227 123.932c7.679-4.438 20.069-4.438 27.747 0 3.897 2.277 5.817 5.196 5.759 8.174-.058 2.861-1.978 5.664-5.759 7.824-7.678 4.437-20.068 4.437-27.746 0-3.549-2.044-5.468-4.73-5.701-7.415-.29-3.095 1.629-6.189 5.7-8.583Z",
    fill: "#0B8BA2"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M15.657 130.705v-16.932h.523c.698-1.46 2.036-2.861 4.014-3.971 6.05-3.503 15.822-3.503 21.813 0 1.978 1.168 3.316 2.511 4.014 3.971h.524v17.224c0 2.277-1.513 4.554-4.538 6.305-6.05 3.504-15.821 3.504-21.813 0-3.2-1.81-4.653-4.203-4.537-6.597Z",
    fill: "#3E666C"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M15.657 130.705v-16.932h.523c.698-1.46 2.036-2.861 4.014-3.971 6.05-3.503 15.822-3.503 21.813 0 1.978 1.168 3.316 2.511 4.014 3.971h.524v17.224c0 2.277-1.513 4.554-4.538 6.305-6.05 3.504-15.821 3.504-21.813 0-3.2-1.81-4.653-4.203-4.537-6.597Z",
    fill: "#67BFC6"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M20.194 107.583c6.05-3.503 15.822-3.503 21.813 0 3.083 1.752 4.596 4.088 4.538 6.423-.059 2.219-1.571 4.437-4.538 6.131-6.05 3.503-15.821 3.503-21.813 0-2.792-1.635-4.304-3.737-4.479-5.839-.233-2.394 1.222-4.846 4.48-6.715Z",
    fill: "#5F9197"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M11.527 112.605v-1.693h.64c.872-1.869 2.56-3.62 5.06-5.08 7.679-4.437 20.069-4.437 27.747 0 2.501 1.46 4.188 3.211 5.06 5.08h.699v2.101c0 2.92-1.92 5.781-5.759 7.999-7.678 4.438-20.068 4.438-27.746 0-4.014-2.335-5.934-5.371-5.701-8.407Z",
    fill: "#087684"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M42.066 104.839c-5.352-5.547-15.124-3.97-21.988 0-3.316 1.927-4.77 4.438-4.537 6.89l-4.109.004c-.29-3.095 1.666-6.193 5.737-8.587 7.679-4.438 20.069-4.438 27.747 0 3.897 2.277 5.817 5.196 5.759 8.174a5.258 5.258 0 0 1-2.269.934c-1.454.234-2.56-.292-3.025-.467-.29-1.927-1.105-4.671-3.315-6.948Z",
    fill: "#284D68"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M33.457 102.212v3.328c-5.934 3.445-11.925 6.89-17.858 10.334v-3.328l17.858-10.334Z",
    fill: "#456C71"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M33.457 95.264v10.218l12.913 7.415v-10.218c0-4.087-2.908-9.05-6.456-11.094-3.607-2.043-6.457-.408-6.457 3.679Z",
    fill: "#5FC7DA"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "m46.312 112.955-2.967 1.693-11.11-21.778 3.141-1.81 10.936 21.895Z",
    fill: "#5FC7DA"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M30.432 97.016v10.217l12.913 7.415v-10.217c0-4.087-2.908-9.05-6.456-11.094-3.549-2.043-6.457-.409-6.457 3.678Z",
    fill: "#209BA5"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "m15.54 111.671 12.565 7.59 15.945-8.451-13.618-7.839-14.891 8.7Z",
    fill: "#284D68"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M43.62 23.724c-.758-.438-1.11-1.111-.878-1.514.233-.403 1.043-.406 1.75.003.76.438 1.112 1.112.88 1.515-.212.482-.993.434-1.752-.004Z",
    fill: "#5E7F84"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M49.66 17.002c-.012-3.835 1.741-6.988 3.962-6.982 2.221.007 4.08 3.094 4.09 6.93.062 3.863-1.742 6.986-3.963 6.98-2.221-.006-4.028-3.064-4.09-6.928Z",
    fill: "#137B89"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M53.75 23.93c-.017-4.643-.032-9.287-.048-13.93-.94-.006-1.83.017-2.771.011.095 4.623.19 9.245.307 13.947.81-.002 1.65-.055 2.511-.028Z",
    fill: "#137B89"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M46.917 16.963c-.09-3.813 1.713-6.937 3.934-6.93 2.221.006 4.08 3.094 4.09 6.928.01 3.835-1.742 6.988-3.963 6.981-2.221-.006-4.05-3.144-4.061-6.979Z",
    fill: "#284D68"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M29.734 48.846c0-.058 0-.058 0 0 .058-.058.058-.058 0 0 .64-.35 1.454-.292 2.326.234 1.804 1.05 3.258 3.561 3.258 5.663 0 1.051-.349 1.81-.989 2.102l-7.562 4.38c-2.85-1.986-6.05-3.562-9.016-5.43 6.108-3.562 11.692-6.832 11.983-6.949Z",
    fill: "#137B89"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M13.97 66.83c-1.978.525-4.246-1.81-5.119-5.197-.872-3.386 0-6.598 1.978-7.123 1.978-.526 4.246 1.81 5.119 5.196.872 3.445 0 6.598-1.978 7.123Z",
    fill: "#209BA5"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M43.81 32.148c-9.074 15.881-11.808 20.61-20.882 36.492-3.606-2.22-7.271-4.38-10.878-6.598 9.133-15.94 11.867-20.727 21-36.667 3.548 2.277 7.154 4.496 10.76 6.773Z",
    fill: "#6ED0D8"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M43.694 32.206c-1.047 1.752-4.304 1.752-7.329-.058-3.025-1.752-4.653-4.671-3.606-6.423 1.047-1.751 4.304-1.751 7.329.059 3.025 1.81 4.653 4.67 3.606 6.422Z",
    fill: "#4FBCD0"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M34.812 26.455c-.116.175-.465.175-.756 0-.349-.175-.523-.525-.407-.7.116-.176.465-.176.756 0 .35.175.524.525.407.7Z",
    fill: "#0E4047"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M41.367 30.513c-.523.876-2.21.876-3.722 0-1.513-.934-2.385-2.394-1.862-3.27.524-.876 2.21-.876 3.723 0 1.57.876 2.385 2.336 1.861 3.27Z",
    fill: "#137B89"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M49.802 15.8c-4.653 8.115-3.78 6.597-8.434 14.713-1.862-1.11-3.665-2.219-5.526-3.328 4.653-8.116 3.839-6.656 8.434-14.772 1.862 1.11 3.665 2.277 5.526 3.386Z",
    fill: "#137B89"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M46.045 20.692c-.496-.892.347-2.353 1.862-3.224 1.565-.843 3.265-.869 3.762.022.497.892-.347 2.353-1.861 3.224-1.595.893-3.266.869-3.763-.022Z",
    fill: "#5F9197"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "m7.804 63.034-.698-1.226c.524-.292 12.855-7.356 13.379-7.648.582-.292 1.396-.234 2.268.233 1.804 1.051 3.258 3.562 3.258 5.664 0 1.05-.349 1.81-.989 2.102l-13.379 7.648-.698-1.226c-1.687-1.05-3.14-3.503-3.14-5.547Z",
    fill: "#137B89"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M9.433 62.1c1.803 1.051 3.257 3.562 3.257 5.664 0 2.043-1.454 2.919-3.257 1.868-1.803-1.051-3.258-3.562-3.258-5.664 0-2.101 1.455-2.919 3.258-1.868Z",
    fill: "#53898F"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M30.025 104.372c-2.618-4.437-2.618-9.283-.058-10.801 2.559-1.518 6.805.875 9.423 5.371 2.617 4.438 2.617 9.284.058 10.802-2.618 1.459-6.806-.934-9.423-5.372Z",
    fill: "#66C9DB"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "m39.39 109.685-8.725 5.08-8.493-10.918 12.913-6.19c1.455 4.029 2.85 8.058 4.305 12.028Z",
    fill: "#66C9DB"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M23.277 60.465c5.817 13.838 11.634 27.676 17.392 41.513a28.119 28.119 0 0 0-2.675-1.926c-3.432-1.986-6.515-2.044-8.61-.526l-1.163.701-13.379-40.813c2.85.35 5.643.701 8.435 1.051Z",
    fill: "#66C9DB"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M6.175 64.436v.117l3.142 5.196L32.002 107l8.726-5.021c-8.26-15.707-16.52-31.413-24.78-47.06-2.85 1.635-5.759 3.328-8.61 4.963-.406 1.518-.755 3.036-1.163 4.554Z",
    fill: "#66C9DB"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M6.175 64.436c.059.233.117.467.233.759v.058l12.914 38.711.872.875.466-.233c2.094-1.518 5.177-1.46 8.608.525.931.526 1.804 1.168 2.676 1.927a12660.035 12660.035 0 0 0-17.509-41.63c-2.675-.35-5.467-.642-8.26-.992Z",
    fill: "#CBEAEE"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M21.241 109.393c-2.617-4.437-2.617-9.283-.058-10.801 2.56-1.518 6.806.876 9.423 5.372 2.618 4.437 2.618 9.283.058 10.801-2.559 1.46-6.805-.934-9.423-5.372Z",
    fill: "#25757B"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M5.943 62.742c0 .526.058 1.11.232 1.694V64.61c.059.233.117.408.175.642v.058c.582 1.635 1.629 3.27 2.908 4.38.35.35.757.583 1.164.817 2.501 1.401 4.479.292 4.479-2.57 0-.291 0-.583-.059-.933-.29-2.102-1.512-4.321-3.082-5.84-.408-.408-.873-.7-1.338-.992-2.443-1.4-4.48-.233-4.48 2.57Z",
    fill: "#209BA5"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M14.668 57.721c0 .526.058 1.11.233 1.694V59.59c.058.233.116.408.174.642v.058a10.925 10.925 0 0 0 2.909 4.438c.349.35.756.584 1.163.817 2.501 1.46 4.537.292 4.537-2.569 0-.292 0-.584-.058-.934-.29-2.102-1.512-4.38-3.141-5.839a5.304 5.304 0 0 0-1.338-.992c-2.443-1.518-4.479-.35-4.479 2.51Z",
    fill: "#66C9DB"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "m7.804 63.034-.698-1.226c.524-.292.465-.292.989-.584.582-.291 1.396-.233 2.269.234 1.803 1.051 3.257 3.562 3.257 5.663 0 1.052-.349 1.81-.989 2.102l-.989.584-.698-1.226c-1.687-1.05-3.14-3.503-3.14-5.547Z",
    fill: "#327C86"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M9.433 62.1c1.803 1.051 3.257 3.562 3.257 5.664 0 2.043-1.454 2.919-3.257 1.868-1.803-1.051-3.258-3.562-3.258-5.664 0-2.101 1.455-2.919 3.258-1.868Z",
    fill: "#CBEAEE"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M48.057 26.076c-1.047 1.751-4.304 1.751-7.33-.059-3.024-1.81-4.653-4.67-3.606-6.422 1.047-1.752 4.305-1.752 7.33.058 3.024 1.81 4.653 4.671 3.606 6.423Z",
    fill: "#30B1BB"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M54.746 14.398C45.672 30.28 57.073 10.311 48 26.192c-3.607-2.218-7.271-4.379-10.878-6.597 9.133-15.94-2.268 3.97 6.864-11.97a2917.77 2917.77 0 0 0 10.761 6.773Z",
    fill: "#30B1BB"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M54.863 14.281c-1.047 1.752-4.305 1.752-7.33-.058-3.024-1.81-4.653-4.671-3.606-6.423 1.047-1.751 4.304-1.751 7.33.059 2.966 1.81 4.595 4.67 3.606 6.422Z",
    fill: "#66C9DB"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M38.683 16.978c-.01-3.835 1.742-6.987 3.963-6.98 2.221.005 4.08 3.093 4.09 6.928.011 3.835-1.742 6.987-3.963 6.98-2.221-.005-4.079-3.093-4.09-6.928Z",
    fill: "#284D68"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "m40.63 18.34-.233-.41c-1.338.76-2.327 1.519-3.025 2.336-.582.642-.93 1.285-1.105 1.927 0 .058 0 .058-.059.117-.058.35-.232.875-.523 1.518-.35.817-.873 1.518-1.57 2.16l.348.35c.698-.7 1.28-1.46 1.63-2.277.348-.7.464-1.284.58-1.635 0-.058 0-.116.059-.116.29-1.402 1.629-2.745 3.897-3.97Z",
    fill: "#0E4047"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "m42.773 23.907-.047-13.93c-.94-.007-1.83.017-2.771.011.095 4.623.19 9.245.308 13.947.76-.031 1.65-.055 2.51-.028Z",
    fill: "#284D68"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M35.861 16.961c-.01-3.835 1.742-6.987 3.964-6.981 2.22.006 4.079 3.094 4.09 6.929.01 3.835-1.742 6.987-3.963 6.98-2.171.024-4.03-3.064-4.09-6.928Z",
    fill: "#257581"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M38.72 14.111c.023-.39.017-.729-.01-1.148.52.032.419-.026.94.006.52.032 1.127.382 1.501 1.136.828 1.485.872 3.861.029 5.322-.437.756-.98 1.114-1.58 1.103l-.941-.006c.023-.39-.034-.759-.012-1.148-.697-1.478-.69-3.825.073-5.265Z",
    fill: "#66C9DB"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M40.29 14.078c.828 1.485.872 3.861.029 5.322-.844 1.461-2.255 1.453-3.083-.033-.827-1.485-.871-3.862-.028-5.322.844-1.461 2.255-1.453 3.082.033Z",
    fill: "#209BA5"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M18.565 103.847v10.217l12.914 7.415v-10.217c0-4.087-2.909-9.05-6.457-11.094-3.606-2.043-6.457-.35-6.457 3.679Z",
    fill: "#5FC7DA"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "m17.344 101.511 3.141-1.81 8.958 17.808c-1.105.409-2.21.759-3.316 1.11l-8.783-17.108Z",
    fill: "#5FC7DA"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M15.54 105.598c0-4.087 2.91-5.722 6.457-3.678 3.549 2.044 6.457 7.006 6.457 11.094v7.999h-3.897l-9.016-5.197v-10.218Z",
    fill: "#259DA7"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M18.507 107.35c0 2.219 1.513 4.846 3.432 5.955 1.862 1.11 3.432.234 3.432-1.985 0-2.218-1.512-4.846-3.432-5.955-1.92-1.11-3.432-.234-3.432 1.985Zm.756.409c0-1.752 1.222-2.394 2.676-1.577 1.454.876 2.676 2.978 2.676 4.671s-1.222 2.394-2.676 1.577c-1.512-.818-2.675-2.92-2.675-4.671Z",
    fill: "#18838C"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M22.056 111.495c1.105.643 2.035.117 2.035-1.167 0-1.285-.93-2.861-2.035-3.562-1.106-.642-2.036-.117-2.036 1.168 0 1.284.93 2.919 2.036 3.561Z",
    fill: "#2AA1AA"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M28.454 119.961v1.11h3.897c4.654-2.686 9.307-5.372 14.02-8.116V109.627l-2.968 1.693-.116.059-12.739 7.356-1.28.759-.814.467Z",
    fill: "#456C71"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M28.454 119.027v1.11h3.897c4.654-2.686 9.366-5.372 14.02-8.116.115-1.168.232-2.394.348-3.562l-3.316 1.985-.116.059-12.739 7.356-1.28.759-.814.409Z",
    fill: "#284D68"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M14.493 114.298c4.48 2.627 9.017 5.196 13.496 7.824l.523-1.11.756-1.518h-.058l-.698-.408-14.019-8.058v.701c.059.876.059 1.751 0 2.569Z",
    fill: "#203F56"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M11.432 111.634c.234 2.64 2.162 5.281 5.727 7.29 7.714 4.362 20.161 4.362 27.875 0 3.74-2.124 5.669-4.879 5.786-7.692-1.403-.115-2.688 0-4.091-.115h-.292c-.994.058-1.987.058-2.98.115h-.059l-.058.058c-4.091 3.845-8.59 6.256-12.799 7.232l-1.285.746-.701-.402c-3.215.402-6.195-.115-8.532-1.55-1.17-.746-3.496-3.12-4.898-6.506l-3.693.824Z",
    fill: "#284D68"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M49.391 16.923c.186.123.186.494 0 .803-.186.371-.558.556-.744.433-.186-.124-.186-.494 0-.803.186-.371.558-.557.744-.433Z",
    fill: "#093C43"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M49.423 18.681c.658-.658 1.446-.834 1.796-.485.35.35.129 1.182-.485 1.796-.658.658-1.447.835-1.796.485-.394-.305-.173-1.138.485-1.796Z",
    fill: "#115762"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "m53.309 24.847-4.48-4.481 2.28-2.28 4.48 4.48-2.28 2.28Z",
    fill: "#125762"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "m49.292 17.49-.5.108a11.376 11.376 0 0 0 1.881 3.594c.542.75 1.143 1.273 1.79 1.628.092-.069.322-.303.247-.417-1.435-.687-2.685-2.358-3.418-4.913Z",
    fill: "#093C43"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m49.736 25.513 4.955-.52 4.956-.521.01.01 4.14 1.466-.016.043.054-.006 4.425 4.426-.014.001.024.009-1.272 3.591-2.571-.91 1.092-3.084-3.222-3.221-2.033-.72-4.062.426-4.116.433-.344.97 3.222 3.222 6.464 2.289-.434 1.226-7.53-2.666.004-.012-.014.002-4.462-4.463h-.001l.703-1.986.071.025-.03-.03Z",
    fill: "#76CCDC"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "m66.414 27.129-3.242-3.23-.891 2.878 3.274 3.262.86-2.91ZM52.947 26.844V24.06l8.191-.857-.822 2.866-7.369.775Z",
    fill: "#6ED0E2"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m50.615 22.638 4.956-.521 4.955-.52.01.01 4.17 1.504.008-.001 4.425 4.425-.014.002.024.008-1.272 3.592-2.57-.91 1.091-3.084-3.221-3.222-2.034-.72-4.061.427-4.117.433-.344.97 3.222 3.221 6.464 2.29-.434 1.226-7.53-2.667.004-.011-.014.001-4.425-4.425.053-.006-.09-.032.703-1.986.07.026-.029-.03Z",
    fill: "#37929E"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "m49.044 27.515.863-2.846 4.415 4.387-.892 2.892-4.386-4.433Z",
    fill: "#6ED0E2"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "m61.852 31.715-7.53-2.668-.91 2.92 7.577 2.64.863-2.892ZM60.318 26.084l.827-2.902 2.027.717-.886 2.896-1.968-.71Z",
    fill: "#53BBCE"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "m64.45 33.115.859-2.904 2.558.89-.859 2.926-2.558-.912Z",
    fill: "#76CCDC"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "m52.617 25.019.338-.958v1.314l-.338-.356Z",
    fill: "#53BBCE"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "m61.843 31.698.453-1.154-.868 2.867-.435 1.21.85-2.923Z",
    fill: "#6ED0E2"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "m67.866 31.098 1.285-3.551-.876 2.86-1.27 3.609.861-2.918Z",
    fill: "#127E87"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M23.198 186.478c.975-.565 1.763-.102 1.763 1.028.014 1.072-.731 2.462-1.763 3.056-1.017.579-1.777.072-1.777-1.014V189.2c0-.014 0-.029.014-.043v-.015c0-.014 0-.029.015-.043v-.015c0-.014.014-.028.014-.043 0-.029.014-.043.014-.058.015-.029.015-.043.015-.058v-.014c0-.015.014-.029.014-.044.014-.029.014-.043.014-.058v-.014c0-.015.015-.029.015-.044v-.014c0-.015.014-.029.014-.044.014-.029.014-.043.014-.057.015-.029.015-.044.015-.058.014-.029.014-.044.014-.058.014-.029.014-.044.014-.058.015-.029.015-.044.015-.058.014-.029.014-.044.014-.058.014-.029.014-.044.029-.058.014-.029.014-.044.014-.058.014-.029.014-.043.029-.058.014-.029.014-.043.028-.058.015-.029.015-.043.029-.058.014-.029.014-.043.029-.058.014-.029.014-.043.028-.058.015-.029.015-.043.029-.058.014-.029.014-.043.029-.058.014-.029.014-.043.028-.057 0-.015.015-.015.015-.015.014-.014.014-.029.014-.043 0-.015.014-.015.014-.015.015-.014.015-.029.015-.043 0-.015.014-.015.014-.015.014-.014.014-.029.014-.043 0-.015.015-.015.015-.015.014-.014.014-.029.028-.043 0-.015.015-.015.015-.015.014-.014.014-.029.028-.043 0-.015.015-.015.015-.015.014-.014.014-.029.014-.043 0-.015.014-.015.014-.015.015-.014.015-.014.015-.043 0-.014.014-.014.014-.014.014-.015.014-.015.014-.044 0-.014.015-.014.015-.014.014-.015.014-.015.014-.029 0-.015.014-.015.014-.015.015-.014.015-.014.015-.029l.014-.014.029-.029c0-.015.014-.015.014-.015l.029-.029.014-.014c.014-.015.014-.015.014-.029l.015-.015c.014-.014.014-.014.014-.029l.014-.014.029-.029.014-.015.029-.029.014-.014.029-.029.014-.014c.015-.015.015-.015.015-.029l.014-.015c.014-.014.014-.014.029-.014l.014-.015.029-.029.014-.014c.014-.015.014-.015.029-.015l.014-.014.014-.015.015-.014c.014-.015.014-.015.028-.015l.015-.014c.014-.015.014-.015.028-.015l.015-.014c.014-.015.014-.015.028-.015l.015-.014c.014-.015.014-.015.028-.015l.015-.014c.014-.015.014-.015.028-.015l.015-.014c.014-.015.014-.015.028-.015s.014-.014.014-.014c.015-.015.015-.015.03-.015l.013-.014c.015-.014.015-.014.03-.014l.014-.015c.014-.014.014-.014.028-.014.015 0 .015-.015.015-.015.014-.014.014-.014.028-.014.015 0 .015-.015.015-.015.014-.014.014-.014.028-.014.014.058.029.058.043.058Z",
    fill: "#76CAD6",
    fillOpacity: 0.3
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M16.061 185.319c.96-1.637 2.064-3.114 3.282-4.374l.358-.377.444-.42.259-.231.229-.203.258-.217.23-.189c.1-.086.185-.144.257-.202l.23-.189c.128-.101.257-.188.372-.275l.115-.087c.129-.087.243-.173.372-.26l.115-.087c.129-.087.244-.16.372-.232l.359-.217.358-.203.272-.13.33-.16.3-.13.288-.116.33-.13.286-.102.086-.029a7.61 7.61 0 0 1 2.336-.391c.888 0 1.705.189 2.393.551l-1.72 2.998a4.382 4.382 0 0 0-1.863-.42c-.716 0-1.476.159-2.264.478l-.258.116-.2.086-.187.087-.186.102-.258.145-.115.057c-2.107 1.232-3.884 3.071-5.431 5.634l-1.749-.883Z",
    fill: "#91D5DE"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "m14.958 184.754-3.526-2.042 3.526 2.042Z",
    fill: "#76CAD6"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "m13.31 183.755.014-.044a32.264 32.264 0 0 1 4.844-6.329 30.29 30.29 0 0 1 2.279-2.071c.487-.391.931-.724 1.361-1.014.2-.13.401-.275.602-.405l.3-.189c.03-.014.058-.043.087-.058l.817-.477a.687.687 0 0 0 .1-.044c.401-.232.846-.449 1.333-.652a13.086 13.086 0 0 1 2.622-.84c.674-.13 1.333-.202 1.964-.202.86 0 1.691.13 2.465.405.2.073.401.159.587.246.087.044.187.087.287.116a144.43 144.43 0 0 1-1.748 3.027h-.015a6.089 6.089 0 0 0-2.35-.623c-.143-.014-.287-.014-.444-.014-.918 0-1.92.188-2.938.536l-.33.116-.23.087-.157.057-.129.058-.33.145-.386.188-.23.116c-.129.058-.2.116-.286.16l-.172.101c-.2.116-.344.203-.473.29l-.187.116c-2.751 1.766-5.188 4.315-7.223 7.574a4.344 4.344 0 0 0-.2.348l-.13.217c-.013 0-1.69-.941-1.705-.941Z",
    fill: "#76CAD6",
    fillOpacity: 0.8
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "m18.784 186.854.23-.377.272-.42.243-.347.258-.333s.187-.247.2-.261l.259-.319.215-.246.057-.058c.158-.188.33-.362.502-.521l.286-.275.373-.333.301-.261.387-.304.272-.189.258-.173c.115-.073.215-.131.33-.203.086-.044.157-.087.23-.13l.357-.189.287-.13.301-.116.186-.058.172-.058.158-.043.158-.044.157-.043c.316-.073.63-.102.917-.102h.158l.129.015.129.014.057.015.13.014.128.029.058.015.172.043.143.044.143.058.115.058.057.029c-.2.376-1.347 2.375-1.634 2.853a2.39 2.39 0 0 0-.702-.189l-.129-.014h-.215l-.114.014-.115.015-.158.029-.143.029-.043.014a4.167 4.167 0 0 0-.903.348l-.129.058-.114.058c-1.075.623-1.978 1.564-2.767 2.853l-1.619-.869Z",
    fill: "#76CAD6",
    fillOpacity: 0.3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "signuphero_svg__a",
    x1: 330.75,
    y1: 169.812,
    x2: 330.75,
    y2: 126.459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.023,
    stopColor: "#EFFBFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEF4F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "signuphero_svg__b",
    x1: 294.868,
    y1: 151.801,
    x2: 366.627,
    y2: 151.801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.074,
    stopColor: "#A2D6E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998,
    stopColor: "#50D7E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "signuphero_svg__c",
    x1: 492.736,
    y1: 93.544,
    x2: 571.942,
    y2: 141.208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#24444A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#754067"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "signuphero_svg__d",
    x1: 1.876,
    y1: 0,
    x2: 1.876,
    y2: 7.686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C2051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#753F67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "signuphero_svg__e",
    x1: 108.955,
    y1: 4.648,
    x2: 57.389,
    y2: -38.922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2FDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9FEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "signuphero_svg__f",
    x1: 35.143,
    y1: 14.424,
    x2: 18.6,
    y2: -1.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2FDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9FEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "signuphero_svg__g",
    x1: 35.356,
    y1: 14.233,
    x2: 17.415,
    y2: -3.334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2FDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2FDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "signuphero_svg__h",
    x1: 36.385,
    y1: 10.822,
    x2: 19.021,
    y2: -7.491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2FDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9FEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "signuphero_svg__i",
    x1: 471.861,
    y1: 89.085,
    x2: 513.236,
    y2: 167.189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#015969"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#894C79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "signuphero_svg__k",
    x1: 330.036,
    y1: 45.882,
    x2: 330.036,
    y2: 125.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A92A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#284D68"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "signuphero_svg__l",
    x1: 321.201,
    y1: 53.483,
    x2: 321.201,
    y2: 126.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62CDD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24B4C0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "signuphero_svg__m",
    x1: 343.629,
    y1: 132.458,
    x2: 528.287,
    y2: 222.045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62CDD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.651,
    stopColor: "#921267"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.708,
    stopColor: "#921267"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#921267"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "signuphero_svg__p",
    x1: 229.214,
    y1: 257.961,
    x2: 225.82,
    y2: 252.082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6FBAC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A92A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "signuphero_svg__q",
    x1: 229.214,
    y1: 260.28,
    x2: 224.004,
    y2: 251.256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6AB8C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "signuphero_svg__r",
    x1: 229.214,
    y1: 247.104,
    x2: 238.261,
    y2: 262.773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6AB8C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "signuphero_svg__s",
    x1: 229.261,
    y1: 255.497,
    x2: 227.835,
    y2: 253.238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6AB8C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "signuphero_svg__t",
    x1: 228.942,
    y1: 250.707,
    x2: 229.485,
    y2: 250.707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6AB8C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "signuphero_svg__u",
    x1: 225.998,
    y1: 255.293,
    x2: 225.926,
    y2: 254.752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6AB8C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "signuphero_svg__v",
    x1: 227.403,
    y1: 258.606,
    x2: 227.058,
    y2: 258.415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6AB8C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "signuphero_svg__w",
    x1: 230.969,
    y1: 256.549,
    x2: 231.465,
    y2: 256.012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6AB8C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "signuphero_svg__x",
    x1: 232.432,
    y1: 251.576,
    x2: 232.085,
    y2: 251.249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6AB8C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "signuphero_svg__y",
    x1: 230.122,
    y1: 257.583,
    x2: 228.681,
    y2: 257.583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6AB8C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "signuphero_svg__z",
    x1: 232.009,
    y1: 254.939,
    x2: 231.558,
    y2: 252.571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6AB8C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "signuphero_svg__A",
    x1: 231.647,
    y1: 250.346,
    x2: 230.562,
    y2: 249.828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6AB8C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "signuphero_svg__B",
    x1: 226.725,
    y1: 253.314,
    x2: 227.79,
    y2: 251.729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6AB8C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "signuphero_svg__C",
    x1: 226.377,
    y1: 257.928,
    x2: 225.422,
    y2: 257.005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6AB8C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "signuphero_svg__ah",
    x1: 229.214,
    y1: 253.275,
    x2: 230.471,
    y2: 255.453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6AB8C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "signuphero_svg__ai",
    x1: 228.584,
    y1: 253.392,
    x2: 228.543,
    y2: 253.987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF7F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7CC1CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "signuphero_svg__aj",
    x1: 230.014,
    y1: 252.567,
    x2: 229.972,
    y2: 253.161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF7F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7CC1CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "signuphero_svg__ak",
    x1: 230.456,
    y1: 253.886,
    x2: 230.415,
    y2: 254.481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF7F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7CC1CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "signuphero_svg__al",
    x1: 228.141,
    y1: 255.222,
    x2: 228.1,
    y2: 255.817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF7F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7CC1CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "signuphero_svg__am",
    x1: 229.298,
    y1: 255.521,
    x2: 229.257,
    y2: 256.116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF7F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7CC1CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "signuphero_svg__an",
    x1: 167.794,
    y1: 293.232,
    x2: 164.255,
    y2: 287.103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6FBAC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A92A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "signuphero_svg__ao",
    x1: 167.794,
    y1: 295.65,
    x2: 162.362,
    y2: 286.242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6AB8C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "signuphero_svg__ap",
    x1: 167.794,
    y1: 281.913,
    x2: 177.226,
    y2: 298.249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6AB8C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "signuphero_svg__aq",
    x1: 167.844,
    y1: 290.663,
    x2: 166.357,
    y2: 288.307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6AB8C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "signuphero_svg__ar",
    x1: 167.51,
    y1: 285.67,
    x2: 168.076,
    y2: 285.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6AB8C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "signuphero_svg__as",
    x1: 164.441,
    y1: 290.451,
    x2: 164.366,
    y2: 289.886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6AB8C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "signuphero_svg__at",
    x1: 165.906,
    y1: 293.904,
    x2: 165.546,
    y2: 293.705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6AB8C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "signuphero_svg__au",
    x1: 169.624,
    y1: 291.76,
    x2: 170.141,
    y2: 291.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6AB8C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "signuphero_svg__av",
    x1: 171.148,
    y1: 286.576,
    x2: 170.787,
    y2: 286.234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6AB8C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "signuphero_svg__aw",
    x1: 168.74,
    y1: 292.837,
    x2: 167.238,
    y2: 292.837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6AB8C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "signuphero_svg__ax",
    x1: 170.708,
    y1: 290.082,
    x2: 170.238,
    y2: 287.613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6AB8C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "signuphero_svg__ay",
    x1: 170.33,
    y1: 285.293,
    x2: 169.2,
    y2: 284.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6AB8C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "signuphero_svg__az",
    x1: 165.2,
    y1: 288.387,
    x2: 166.309,
    y2: 286.735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6AB8C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "signuphero_svg__aA",
    x1: 164.836,
    y1: 293.198,
    x2: 163.841,
    y2: 292.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6AB8C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "signuphero_svg__bf",
    x1: 167.794,
    y1: 288.347,
    x2: 169.105,
    y2: 290.617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6AB8C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "signuphero_svg__bg",
    x1: 167.137,
    y1: 288.469,
    x2: 167.094,
    y2: 289.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF7F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7CC1CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "signuphero_svg__bh",
    x1: 168.628,
    y1: 287.609,
    x2: 168.585,
    y2: 288.228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF7F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7CC1CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "signuphero_svg__bi",
    x1: 169.089,
    y1: 288.984,
    x2: 169.046,
    y2: 289.604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF7F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7CC1CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "signuphero_svg__bj",
    x1: 166.676,
    y1: 290.376,
    x2: 166.633,
    y2: 290.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF7F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7CC1CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "signuphero_svg__bk",
    x1: 167.882,
    y1: 290.689,
    x2: 167.839,
    y2: 291.309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF7F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7CC1CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "signuphero_svg__bl",
    x1: 146.72,
    y1: 294.917,
    x2: 146.624,
    y2: 291.515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.305,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46C1C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "signuphero_svg__bm",
    x1: 150.107,
    y1: 292.293,
    x2: 150.356,
    y2: 294.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.305,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46C1C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "signuphero_svg__bn",
    x1: 117.282,
    y1: 274.899,
    x2: 119.313,
    y2: 274.899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "signuphero_svg__j",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 .64885 -3.93789 0 3.938 .649)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBDEE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBDEE4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "signuphero_svg__n",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 8.98302 -35.6852 0 45.005 250.188)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A0DAE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6F7F9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "signuphero_svg__D",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(5.50887 -3.18036 2.75563 4.77318 229.399 254.214)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.794
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "signuphero_svg__F",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(5.50887 -3.18036 2.75563 4.77318 229.399 254.214)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#CDE7EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDE7EC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "signuphero_svg__G",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-29.998 589.097 -300.983) scale(6.36225 5.51257)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.794
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "signuphero_svg__I",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-29.998 589.097 -300.983) scale(6.36225 5.51257)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#CDE7EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDE7EC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "signuphero_svg__J",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-29.998 589.096 -300.981) scale(6.36182 5.51221)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.794
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "signuphero_svg__L",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-29.998 589.096 -300.981) scale(6.36182 5.51221)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#CDE7EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDE7EC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "signuphero_svg__M",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-29.998 589.097 -300.983) scale(6.36093 5.51143)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.794
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "signuphero_svg__O",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-29.998 589.097 -300.983) scale(6.36093 5.51143)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#CDE7EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDE7EC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "signuphero_svg__P",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(5.5088 -3.18029 2.75556 4.7731 229.4 254.214)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.794
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "signuphero_svg__R",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(5.5088 -3.18029 2.75556 4.7731 229.4 254.214)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#CDE7EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDE7EC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "signuphero_svg__S",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(5.5087 -3.18023 2.7555 4.773 229.399 254.215)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.794
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "signuphero_svg__U",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(5.5087 -3.18023 2.7555 4.773 229.399 254.215)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#CDE7EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDE7EC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "signuphero_svg__V",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(5.50974 -3.18083 2.75603 4.77392 229.399 254.214)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.794
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "signuphero_svg__X",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(5.50974 -3.18083 2.75603 4.77392 229.399 254.214)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#CDE7EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDE7EC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "signuphero_svg__Y",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(5.50999 -3.18098 2.75616 4.77413 229.399 254.214)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.794
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "signuphero_svg__aa",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(5.50999 -3.18098 2.75616 4.77413 229.399 254.214)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#CDE7EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDE7EC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "signuphero_svg__ab",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(5.5085 -3.18011 2.75541 4.77284 229.399 254.213)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.794
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "signuphero_svg__ad",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(5.5085 -3.18011 2.75541 4.77284 229.399 254.213)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#CDE7EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDE7EC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "signuphero_svg__ae",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(5.50963 -3.18077 2.75598 4.77382 229.399 254.214)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.794
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "signuphero_svg__ag",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(5.50963 -3.18077 2.75598 4.77382 229.399 254.214)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#CDE7EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDE7EC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "signuphero_svg__aB",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-29.998 623.915 -168.824) scale(6.63136 5.74575)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.794
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "signuphero_svg__aD",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-29.998 623.915 -168.824) scale(6.63136 5.74575)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#CDE7EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDE7EC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "signuphero_svg__aE",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(5.7445 -3.31636 2.87346 4.97732 167.987 289.325)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.794
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "signuphero_svg__aG",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(5.7445 -3.31636 2.87346 4.97732 167.987 289.325)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#CDE7EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDE7EC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "signuphero_svg__aH",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(5.74367 -3.31588 2.87304 4.9766 167.987 289.326)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.794
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "signuphero_svg__aJ",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(5.74367 -3.31588 2.87304 4.9766 167.987 289.326)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#CDE7EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDE7EC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "signuphero_svg__aK",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(5.74241 -3.31515 2.87242 4.97551 167.987 289.325)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.794
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "signuphero_svg__aM",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(5.74241 -3.31515 2.87242 4.97551 167.987 289.325)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#CDE7EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDE7EC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "signuphero_svg__aN",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-29.998 623.912 -168.825) scale(6.63059 5.74508)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.794
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "signuphero_svg__aP",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-29.998 623.912 -168.825) scale(6.63059 5.74508)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#CDE7EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDE7EC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "signuphero_svg__aQ",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-29.998 623.915 -168.824) scale(6.63098 5.74541)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.794
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "signuphero_svg__aS",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-29.998 623.915 -168.824) scale(6.63098 5.74541)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#CDE7EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDE7EC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "signuphero_svg__aT",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-29.998 623.913 -168.824) scale(6.63242 5.74666)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.794
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "signuphero_svg__aV",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-29.998 623.913 -168.824) scale(6.63242 5.74666)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#CDE7EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDE7EC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "signuphero_svg__aW",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(5.74425 -3.31621 2.87334 4.9771 167.987 289.326)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.794
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "signuphero_svg__aY",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(5.74425 -3.31621 2.87334 4.9771 167.987 289.326)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#CDE7EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDE7EC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "signuphero_svg__aZ",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(5.74305 -3.31552 2.87274 4.97607 167.987 289.325)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.794
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "signuphero_svg__bb",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(5.74305 -3.31552 2.87274 4.97607 167.987 289.325)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#CDE7EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDE7EC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "signuphero_svg__bc",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(5.74383 -3.31597 2.87313 4.97674 167.987 289.326)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.794
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "signuphero_svg__be",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(5.74383 -3.31597 2.87313 4.97674 167.987 289.326)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#CDE7EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDE7EC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "signuphero_svg__o"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(116.671 167.737)",
    d: "M0 0h148.935v131.581H0z"
  })))));
};
export default SvgSignuphero;